import React, { Fragment } from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  sendContactus,
  setLayout,
  setPath,
  setPathLayout,
  getPoliciesBasedOnAge,
  getTermsBasedOnPolicy,
  getSumAssuredValidation,
  getCalculations,
  customerPoricyNid,
  policyAdd,
  policyNomineeAdd,
  setReturnalCalculatorData,
} from "../../actions/Utils";
import { axiosNewInstance } from "../../config/Api";

import "react-datepicker/dist/react-datepicker.css";
import Tabs, { Tab } from "react-best-tabs";
import "react-best-tabs/dist/index.css";
import { withRouter } from "react-router-dom";
import LangData from "../common/LangData";
import toast from "react-hot-toast";
import "./styles/customer.scss";
// import DraftTable from "./DraftTable";
import {
  // draftEditPolicies,
  fetchData,
  getFetchData,
  // formatDate,
  policyNameId,
  mapRelationToCode,
} from "../../utils/utils";
// import DateInput from "../contactus/DateInput";
// import { Value } from "sass";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import PremiumcalCulatorform from "../contactus/PremiumcalCulatorform";

class Policyform extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCalculatorModal: false,
      nid_validation: false,
      nid_validation_err_msg: true,
      nid_value: "",
      nominee_nid_value: "",
      appointee_nid_value: "",
      /* Agent lookup state — populated by Check button via agentEnquiryLogin API */
      agent_code: "",
      agent_name: "",
      verified_agent_mobile: "",
      agent_lookup_loading: false,
      agent_lookup_error: "",
      /* Policy-holder NID + Check (search-by-nid). Separate from agent mobile. */
      holder_nid_value: "",
      holder_nid_loading: false,
      holder_nid_error: "",
      /* "Do you have a National ID?" toggle (mirrors hasNomineeNId). */
      hasHolderNid: false,
      customer: {},
      document: null,
      draft_policy_details: {},
      files: [],
      isModalOpen: false,
      isEditing: false,
      showAppointeeForm: false,
      allowMenual: false,
      /* Manual Personal Information form is hidden until the NID lookup runs
         and returns "not found" (mirrors nominee pattern but only opens after Check). */
      allowCustom: false,
      allowAppointeeCustom: false,
      appointees: [],
      currentAppointee: {
        appointee_email: "",
        appointee_first_name: "",
        appointee_last_name: "",
        appointee_birth_date: "",
        appointee_gender: "",
        appointee_national_id: "",
        appointee_relation_id: "",
        appointee_present_address: "",
        appointee_mobile_no: "",
      },
      verifyData: null,
      verificationError: null,
      validator: {
        policy_holder_dob: "",
        policy_id: "",
        term: "",
        sum_assured: "",
        parentage: "",
        accidental_cover: "",
        payment_cycle_mode: "",
        premium_amount: "",
        policy_holder_name: "",
        policy_holder_first_name: "",
        policy_holder_last_name: "",
        policy_holder_gender: "",
        policy_holder_nid: "",
        policy_holder_father_name: "",
        policy_holder_mother_name: "",
        policy_holder_email: "",
        policy_holder_national_id: "",
        policy_holder_mobile_number: "",
        policy_holder_education: "",
        policy_holder_occupation: "",
        policy_holder_annual_income: "",
        policy_holder_place_of_birth: "",
        policy_holder_nationality: "",
        policy_holder_spouse: "",
        // policy_holder_parmanent_address: "",
        policy_holder_present_address: "",
        policy_holder_medical_practitioner: "",
        policy_holder_medical_practitioner_details: "",
        policy_holder_admitted_hospital: "",
        policy_holder_admitted_hospital_details: "",
        policy_holder_remained_absent: "",
        policy_holder_remained_absent_details: "",
        policy_holder_suffering_ailments_pertaining: "",
        policy_holder_suffering_ailments_pertaining_details: "",
        policy_holder_suffered_diabetes_others: "",
        policy_holder_suffered_diabetes_others_details: "",
        policy_holder_bodily_defect_deformity: "",
        policy_holder_bodily_defect_deformity_details: "",
        policy_holder_accident_injury: "",
        policy_holder_accident_injury_details: "",
        policy_holder_used_alcoholic_others: "",
        policy_holder_used_alcoholic_others_details: "",
        policy_holder_good_health: "",
        policy_holder_good_health_details: "",
        policy_holder_aids_hepatitis: "",
        policy_holder_aids_hepatitis_details: "",
        // nominee_name: "",
        nominee_email: "",
        nominee_first_name: "",
        nominee_last_name: "",
        // nominee_father_name: "",
        // nominee_mother_name: "",
        nominee_policy_holder_dob: "",
        nominee_father_name: "",
        nominee_mother_name: "",
        nominee_spouse: "",
        nominee_nid: "",
        // nominee_permanent_address: "",
        nominee_present_address: "",
        customer_id: "",
      },
      // payment_by: 0,
      message: "",
      message_type: "",
      policy: {},
      terms: {},
      modedata: {},
      styleinfo: {
        accidental: "none",
        licterm: "block",
        parentage: "none",
      },
      calculation: null,
      formdata: {
        policy_holder_medical_practitioner: 0,
        policy_holder_admitted_hospital: 0,
        policy_holder_remained_absent: 0,
        policy_holder_suffering_ailments_pertaining: 0,
        policy_holder_suffered_diabetes_others: 0,
        policy_holder_bodily_defect_deformity: 0,
        policy_holder_accident_injury: 0,
        policy_holder_used_alcoholic_others: 0,
        policy_holder_good_health: 1,
        policy_holder_aids_hepatitis: 0,
      },
      policyholder_nid: null,
      policyholder_nominee_nid: null,
      tab_active: 1,
      nominees: [],
      currentNominee: {
        nominee_email: "",
        nominee_first_name: "",
        nominee_last_name: "",
        // nominee_father_name: "",
        // nominee_mother_name: "",
        birth_date: "",
        nominee_gender: "",
        nominee_national_id: "",
        relation_id: "",
        nominee_father_name: "",
        nominee_mother_name: "",
        // nominee_permanent_address: "",
        nominee_present_address: "",
        nominee_mobile_no: "",
      },
      allowNomineeCustom: true,
      errors: {},
      transaction_id: "",
      agency_code: "",
      // agentList: [
      //   { value: 10, label: "00029B003" },
      //   { value: 13, label: "00093B008" },
      //   { value: "AG003", label: "Agent 3" },
      //   { value: "AG004", label: "Agent 4" },
      //   { value: "AG005", label: "Agent 5" },
      // ],
      agentList: [],
      formSubmitting: false,
    };
    this.refs = React.createRef();

    this.handleDateChange = this.handleDateChange.bind(this);
    // Validation Schema using Yup
  }

  parseDateToYmd = (v) => {
    if (v == null || v === "") return "";
    const s = String(v).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
    const ymdSlash = s.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})$/);
    if (ymdSlash) {
      const [, y, mo, d] = ymdSlash;
      return `${y}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    }
    const dmySlash = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (dmySlash) {
      const [, d, mo, y] = dmySlash;
      return `${y}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    }
    const dmyDash = s.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    if (dmyDash) {
      const [, d, mo, y] = dmyDash;
      return `${y}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    }
    return s;
  };

  formatLocalDateToYmd = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  parseYmdToLocalDate = (v) => {
    if (!v) return null;
    const ymd = this.parseDateToYmd(v);
    if (!ymd) return null;
    const parts = ymd.split("-");
    if (parts.length !== 3) return null;
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // 0-indexed
    const day = parseInt(parts[2], 10);
    return new Date(year, month, day);
  };

  handleCalculatorApply = (updatedCalc) => {
    if (!updatedCalc) return;

    // Ensure dateOf_birth exists at the root of the object so the manual form DatePicker
    // (which reads from calCulatorData.dateOf_birth) renders correctly.
    const calcToDispatch = {
      ...updatedCalc,
      dateOf_birth:
        updatedCalc.dateOf_birth ||
        updatedCalc.payload?.dob ||
        updatedCalc.payload?.date_of_birth,
    };

    this.props.setReturnalCalculatorData(calcToDispatch);

    this.setState((prevState) => {
      const updatedCustomer = { ...prevState.customer };

      // Only sync Date of Birth and Gender if the customer object was already populated
      // (e.g. from OCR or Draft). If it's empty (manual policy), leave it empty so we 
      // don't trigger the pre-filled form block unintentionally.
      if (Object.keys(prevState.customer || {}).length > 0) {
        const newDob =
          updatedCalc.dateOf_birth ||
          updatedCalc.payload?.dob ||
          updatedCalc.payload?.date_of_birth;
        if (newDob) {
          updatedCustomer.date_of_birth = newDob;
        }

        const newGender = updatedCalc.payload?.gender || updatedCalc.payload?.propGender;
        if (newGender) {
          updatedCustomer.gender =
            newGender === "M"
              ? "Male"
              : newGender === "F"
              ? "Female"
              : updatedCustomer.gender;
        }
      }

      return {
        customer: updatedCustomer,
        showCalculatorModal: false,
      };
    });

    toast.success(
      this.props.lang === "bn"
        ? "প্ল্যান ও প্রিমিয়াম সফলভাবে আপডেট হয়েছে!"
        : "Plan & premium updated successfully!"
    );
  };

  handleChange = (e) => {
    const name = e.target ? e.target.name : "birth_date";
    const value = e.target ? e.target.value : e;

    this.setState(
      (prevState) => ({
        currentNominee: {
          ...prevState.currentNominee,
          [name]: value, // Dynamically updating state
        },
      }),
      () => {
        if (name === "birth_date") {
          this.checkNomineeAge(value);
        }
      }
    );
  };
  handleAppointeeChange = (e) => {
    const name = e.target ? e.target.name : "appointee_birth_date";
    const value = e.target ? e.target.value : "";

    // Special handling for date fields
    if (name === "appointee_birth_date") {
      const dateValue = value ? this.parseDateToYmd(value) : "";
      this.setState((prevState) => ({
        currentAppointee: {
          ...prevState.currentAppointee,
          [name]: dateValue,
        },
      }));
    } else {
      this.setState((prevState) => ({
        currentAppointee: {
          ...prevState.currentAppointee,
          [name]: value,
        },
      }));
    }
  };
  // handleAppointeeChange = (e) => {
  //   const { name, value } = e.target;

  //   this.setState((prevState) => ({
  //     currentAppointee: {
  //       ...prevState.currentAppointee,
  //       [name]: value,
  //     },
  //   }));
  // };
  checkNomineeAge = (birthDate) => {
    const today = new Date();
    const dob = new Date(birthDate);

    let age = today.getFullYear() - dob.getFullYear(); // ✅ Use let

    // Adjust age if birthdate hasn't occurred yet this year
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--; // ✅ No error now
    }
    if (this.state.appointees?.length > 0 && age < 18) {
      this.setState({
        showAppointeeForm: age < 18,
        // appointees: [],
        // currentAppointee: {},
      });
    } else {
      this.setState({
        showAppointeeForm: age < 18,
        appointees: [],
        // currentAppointee: {}, // --------------------------------------------------- check this now issue arrives
      });
    }
  };

  handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const isPDF = file.type === "application/pdf";
    const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB

    // Only allow PDF
    if (!isPDF) {
      toast.error("Please upload only PDF format file.");
      event.target.value = ""; // Clear the input
      return;
    }

    // Check file size with a small buffer
    const sizeWithBuffer = maxSizeInBytes + 1024;
    // console.log('Size comparison:', {
    //   fileSize: file.size,
    //   maxSize: maxSizeInBytes,
    //   sizeWithBuffer: sizeWithBuffer,
    //   isTooLarge: file.size > sizeWithBuffer
    // });

    if (file.size > sizeWithBuffer) {
      // console.log('File size check failed:', {
      //   fileSize: file.size,
      //   maxSize: maxSizeInBytes,
      //   difference: file.size - maxSizeInBytes
      // });
      toast.error(
        `File size exceeds 2 MB. Please upload a smaller PDF. (Current size: ${(
          file.size /
          (1024 * 1024)
        ).toFixed(2)} MB)`
      );
      event.target.value = "";
      return;
    }

    try {
      const base64Data = await this.convertFileToBase64(file);

      this.setState({
        files: [
          {
            id: Date.now(),
            file: base64Data,
            preview: null,
            fileName: file.name,
            fileType: file.type,
            fileSize: (file.size / 1024).toFixed(2) + " KB",
            isPDF: true,
          },
        ],
      });
    } catch (error) {
      toast.error("Error processing the PDF file. Please try again.");
      event.target.value = "";
    }
    // reader.readAsArrayBuffer(file);
  };

  // Handle file deletion
  handleDelete = (id) => {
    // Clear the file input
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = "";
    }

    this.setState((prevState) => ({
      files: prevState.files.filter((file) => file.id !== id),
    }));
  };

  // -----------------------------
  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  // Close the modal
  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  // Handle the original button click
  // handleSubmit() {
  //   this.openModal();
  // }

  getDraftPolicy = async (id) => {
    const result = await fetchData("customer-policy-details", {
      customer_policy_id: id,
    });
    // const result = draftEditPolicies;

    if (result.success && result.data?.status === 1) {
      const data = result.data.data?.customer_policy_details;
      let agency_code_selected = "";
      if (this.state.agentList?.length > 0) {
        const foundAgent = this.state.agentList.find(
          (option) => option.label === data?.user?.login_id
        );
        agency_code_selected = foundAgent ? foundAgent.value : "";
      }
      this.setState({
        transaction_id: data?.transaction_id ?? "",
        // agency_code: data?.user?.login_id ?? "",
        agency_code: agency_code_selected ?? "",
      });
      // console.log("this.state.agency_code 33333333333 data", data?.user?.login_id)
      if (data?.documents) {
        this.setState({
          document: data?.documents,
        });
      }
      this.props.setReturnalCalculatorData({
        id: data?.id,
        message: "Success",
        instPrem: data?.premium,
        customer_name: false,
        policy: policyNameId[data?.plan] || "Unknown Policy",
        dateOf_birth: data?.customer?.date_of_birth,
        policyId: data?.plan || "Unknown Policy",
        age: data?.customer_age,
        sum_assured: data?.sum_assured,
        term: data?.term,
        mode: data?.mode,
        premium_amount: data?.premium,
        // accidental_cover: data?.accidental_coverage,
        accidental_cover:
          data?.accidental_coverage === "No"
            ? "0"
            : data?.accidental_coverage === "Yes"
              ? "1"
              : null,
        critical_illness_benefit: 0,
        critical_illness_amount: 0,
        documents: data?.documents ?? "", //"documents": "policy/uploads/1743055602_Ejs1niRrV7.jpeg",
        payload: {
          gender: data?.customer?.gender,
          plan: data?.plan,
          policy: data?.plan,
          age: data?.customer_age,
          polTerm: data?.polTerm,
          ppTerm: data?.premium_paying_term,
          doc: data?.date_of_commencement,
          sa: data?.sum_assured,
          // ------------
          abSa: data?.sum_assured,
          trSa: data?.term_rider_sa,
          age2: data?.customer_age,
          abSa2: data?.sum_assured,
          pwbFlag: data?.pwb_flag || "Y",
          propGender: data?.prop_gender || "M",
          lf2CirSa: data?.lf2_cir_sa || "0",
          propAge: data?.customer_age,
          pprTrSa: data?.term_rider_sa,
          // ------------
          cirSa: String(data?.ci_rider_sa), //new
          hcbSa: String(data?.hcb_rider_sa), //new
          scbSa: String(data?.scb_rider_sa), //new
          trSa: String(data?.term_rider_sa), //new
          accidental_cover:
            data?.accidental_coverage === "No"
              ? "0"
              : data?.accidental_coverage === "Yes"
                ? "1"
                : null,
          // accidental_cover: data?.accidental_coverage, //done
          critical_illness:
            data?.critical_illness_rider === "No"
              ? "0"
              : data?.critical_illness_rider === "Yes"
                ? "1"
                : data?.critical_illness_rider === "Other"
                  ? "2"
                  : null,
          hospital_rider: data?.hospital_rider_sum_assured,
          critical_sum: data?.critical_sum,
        },
        questions_answers: data?.questions_answers,
        customer: data?.customer,
        nominee: data?.nominee,
        appointee: data?.appointee,
      });
      if (data && Object.keys(data?.customer || {}).length > 0) {
        const cust = {
          ...data.customer,
          occupation: ["10", "60", "63", "70"].includes(String(data.customer?.occupation))
            ? String(data.customer.occupation)
            : "10",
          annual_income: ["1", "2", "3"].includes(String(data.customer?.annual_income))
            ? String(data.customer.annual_income)
            : "1",
          education: ["S", "I", "G", "P", "O"].includes(String(data.customer?.education))
            ? String(data.customer.education)
            : "S",
        };
        this.setState({
          customer: cust,
          nid_value: cust?.national_id,
          allowCustom: false,
        });
      }
      if (data && Object.keys(data?.nominee || {}).length > 0) {
        // const nominee = [];
        const nomAddress =
          (data?.nominee?.present_address || data?.nominee?.address || "").trim();
        const isCustomerExit = {
          nominee_email: data?.nominee?.email ?? "",
          nominee_first_name: data?.nominee?.first_name ?? "",
          nominee_last_name: data?.nominee?.last_name ?? "",
          birth_date: data?.nominee?.date_of_birth ?? "",
          nominee_gender: data?.nominee?.gender ?? "",
          nominee_national_id: data?.nominee?.national_id ?? "",
          relation_id: data?.nominee?.relation ?? "",
          nominee_present_address: nomAddress || "Same as LA/Proposer",
          nominee_mobile_no: data?.nominee?.mobile ?? "",
        };
        this.setState({
          currentNominee: { ...isCustomerExit },
          nominee_nid_value: data?.nominee?.national_id,
          allowCustom: false,
          allowNomineeCustom:
            !!data?.nominee?.national_id || !!data?.nominee?.id,
          hasNomineeNId: !!data?.nominee?.national_id,
        });
      }
      if (data && Object.keys(data?.appointee || {}).length > 0) {
        const currentAppointees = {
          appointee_email: data?.appointee?.email_address ?? "",
          appointee_first_name: data?.appointee?.first_name,
          appointee_last_name: data?.appointee?.last_name,
          // appointee_father_name: data?.appointee?.birth_date,
          // appointee_mother_name: data?.appointee?.gender,
          appointee_birth_date: data?.appointee?.birth_date,
          appointee_gender: data?.appointee?.gender,
          appointee_national_id: data?.appointee?.national_id,
          appointee_relation_id: data?.appointee?.national_id,
          // appointee_permanent_address: "",
          appointee_present_address: data?.appointee?.present_address,
          appointee_mobile_no: data?.appointee?.mobile_no,
        };
        // const nominee = [];
        // nominee.push(data?.nominee);
        this.setState({ currentAppointee: { ...currentAppointees } });
        this.setState({ allowAppointeeCustom: true });
      }
      if (data && Object.keys(data?.questions_answers || {}).length > 0) {
        const questionsAnswers = data.questions_answers;

        const updatedFormData = {
          ...this.state.formdata,
          ...questionsAnswers,
        };

        const updatedValidator = {
          ...this.state.validator,
          ...Object.keys(questionsAnswers).reduce((acc, key) => {
            acc[key] = this.state.validator[key] || "";
            return acc;
          }, {}),
        };

        // Set radio button values and textarea values based on questions_answers
        const radioFields = [
          "policy_holder_medical_practitioner",
          "policy_holder_admitted_hospital",
          "policy_holder_remained_absent",
          "policy_holder_suffering_ailments_pertaining",
          "policy_holder_suffered_diabetes_others",
          "policy_holder_bodily_defect_deformity",
          "policy_holder_accident_injury",
          "policy_holder_used_alcoholic_others",
          "policy_holder_good_health",
          "policy_holder_aids_hepatitis",
        ];

        radioFields.forEach((field) => {
          const radioRef = this[field];
          if (radioRef) {
            // Set radio button value
            radioRef.value = questionsAnswers[field] || "0";
            radioRef.checked = questionsAnswers[field] === 1;
          }

          // Set textarea value if radio is checked
          const detailsRef = this[`${field}_details`];
          if (detailsRef && questionsAnswers[field] === 1) {
            detailsRef.value = questionsAnswers[`${field}_details`] || "";
            detailsRef.readOnly = false;
          } else if (detailsRef) {
            detailsRef.value = "";
            detailsRef.readOnly = true;
          }
        });

        // Set values for blood information, pulse rate, height, weight, and smoker status
        if (this.policy_holder_blood_information) {
          this.policy_holder_blood_information.value =
            questionsAnswers?.blood || "";
        }
        if (this.policy_holder_pulse_rate) {
          this.policy_holder_pulse_rate.value =
            questionsAnswers?.pulse_rate || "";
        }
        if (this.policy_holder_height) {
          this.policy_holder_height.value = questionsAnswers?.height || "";
        }
        if (this.policy_holder_weight) {
          this.policy_holder_weight.value = questionsAnswers?.weight || "";
        }
        if (this.policy_holder_smoker_status) {
          this.policy_holder_smoker_status.value =
            questionsAnswers?.smoker_status || "";
        }
        this.setState({
          formdata: updatedFormData,
          validator: updatedValidator,
        });
      }
    } else {
      console.error("Error fetching data:", result.error);
    }
  };

  // Handle the Edit button click inside the modal
  handleEdit = (id) => {
    this.getDraftPolicy(id);
    this.closeModal();
    this.setState({ isEditing: true });
  };

  // Handle the Update button click
  handleUpdate = () => {
    // Add your update logic here
    this.setState({ isEditing: false });
  };

  // Handle the Cancel button click
  handleCancel = () => {
    this.setState({ isEditing: false });
    this.props.history.push("/premium-calculator");
  };

  // -----------------------------

  validateFields = () => {
    const {
      // nominee_email,
      nominee_first_name,
      nominee_last_name,
      birth_date,
      nominee_gender,
      relation_id,
      // nominee_national_id,
      nominee_present_address,
      nominee_mobile_no,
    } = this.state.currentNominee;
    const errors = {};
    console.log("values 32223332", this.state.currentNominee);
    // if (!nominee_email.trim())
    //   errors.nominee_email = "Nominee email is required";
    if (!nominee_first_name.trim())
      errors.nominee_first_name = "Nominee first name is required";
    if (!nominee_last_name.trim())
      errors.nominee_last_name = "Nominee last name is required";
    if (!birth_date) errors.birth_date = "Date of birth is required";
    if (!nominee_gender) errors.nominee_gender = "Gender is required";
    if (!relation_id) errors.relation_id = "Relation is required";

    // Updated NID validation to match handleNonmineePorichoy
    // if (!nominee_national_id?.trim()) {
    //   errors.nominee_national_id = "National ID is required";
    // } else if (!/^\d{10,17}$/.test(nominee_national_id)) {
    //   errors.nominee_national_id = "NID must be 10, 13 or 17 digits";
    // }

    if (!(nominee_present_address || "").trim())
      errors.nominee_present_address = "Present address is required";
    if (!(nominee_mobile_no || "").trim())
      errors.nominee_mobile_no = "Mobile number is required";
    else if (!/^\d{11}$/.test(nominee_mobile_no))
      errors.nominee_mobile_no = "Mobile number must be 11 digits";

    return errors;
  };

  /**
   * Personal info must match premium calculator gender & DOB.
   * NID/API may return Male/Female/mixed case; calculator uses M/F. DOB may be YYYY-MM-DD or DD/MM/YYYY.
   */
  genderDobMatchesCalculator = (personalInfo, calCulatorData) => {
    const normalizeGender = (g) => {
      const u = (g ?? "").toString().trim().toUpperCase();
      if (u === "M" || u === "MALE") return "M";
      if (u === "F" || u === "FEMALE") return "F";
      return u;
    };
    const pg = normalizeGender(personalInfo?.gender);
    const cg = normalizeGender(
      calCulatorData?.payload?.gender ?? calCulatorData?.gender
    );
    const pd = this.parseDateToYmd(personalInfo?.date_of_birth);
    const calcDobRaw =
      calCulatorData?.dateOf_birth ??
      calCulatorData?.payload?.dob ??
      calCulatorData?.payload?.date_of_birth;
    const cd = this.parseDateToYmd(calcDobRaw);
    return pg === cg && pd !== "" && cd !== "" && pd === cd;
  };

  validateSaveConfirmFields = (personalInfo) => {
    const errors = {};
    // if (!personalInfo?.email_address?.trim())
    //   errors.policy_holder_email = "Email is required";
    if (!personalInfo?.date_of_birth)
      errors.policy_holder_dob = "Date of birth is required";
    if (!personalInfo?.customer_first_name?.trim())
      errors.policy_holder_first_name = "First name is required";
    if (!personalInfo?.customer_last_name?.trim())
      errors.policy_holder_last_name = "Last name is required";
    if (!personalInfo?.father_name?.trim())
      errors.policy_holder_father_name = "Father name is required";
    // if (!personalInfo?.mother_name?.trim())
    //   errors.policy_holder_mother_name = "Mother name is required";
    if (!personalInfo?.gender)
      errors.policy_holder_gender = "Gender is required";
    if (!personalInfo?.occupation)
      errors.policy_holder_occupation = "Occupation is required";
    if (!personalInfo?.annual_income)
      errors.policy_holder_annual_income = "Annual income field is required";
    if (!personalInfo?.place_of_birth)
      errors.policy_holder_place_of_birth = "Place of birth field is required";
    if (!personalInfo?.nationality)
      errors.policy_holder_nationality = "Nationality field is required";
    // if (!personalInfo?.spouse_name)
    //   errors.policy_holder_spouse = "Spouse field is required";
    // if (!personalInfo?.education)
    //   errors.policy_holder_education = "Education field is required";
    // National ID validation
    const nationalId = String(personalInfo?.national_id || "").trim();
    if (!nationalId) {
      errors.policy_holder_national_id = "National ID is required";
    } else if (!/^\d{10,17}$/.test(nationalId)) {
      errors.policy_holder_national_id = "National ID must be 10-17 digits.";
    }

    // Address validation
    // if (!personalInfo?.permanent_address?.trim())
    //   errors.policy_holder_permanent_address = "Permanent address is required";
    if (!personalInfo?.present_address?.trim())
      errors.policy_holder_present_address = "Present address is required";

    // Mobile number validation
    const mobileNo = String(personalInfo?.mobile_no || "").trim();
    if (!mobileNo) {
      errors.policy_holder_mobile_number = "Mobile number is required";
    } else if (!/^\d{11}$/.test(mobileNo)) {
      errors.policy_holder_mobile_number =
        "Mobile number must be exactly 11 digits.";
    }

    return errors;
  };
  validateDraftSaveConfirmFields = (personalInfo) => {
    const errors = {};
    // if (!personalInfo?.email_address?.trim())
    //   errors.policy_holder_email = "Email is required";
    if (!personalInfo?.national_id)
      errors.national_id = "National ID is required";
    if (!personalInfo?.date_of_birth)
      errors.policy_holder_dob = "Date of birth is required";
    if (!personalInfo?.customer_first_name?.trim())
      errors.policy_holder_first_name = "First name is required";
    if (!personalInfo?.customer_last_name?.trim())
      errors.policy_holder_last_name = "Last name is required";
    // Mobile number validation
    const mobileNo = String(personalInfo?.mobile_no || "").trim();
    if (!mobileNo) {
      errors.policy_holder_mobile_number = "Mobile number is required";
    } else if (!/^\d{11}$/.test(mobileNo)) {
      errors.policy_holder_mobile_number =
        "Mobile number must be exactly 11 digits.";
    }

    return errors;
  };

  appointeeValidateFields = () => {
    const {
      // appointee_email,
      appointee_first_name,
      appointee_last_name,
      // appointee_father_name,
      // appointee_mother_name,
      appointee_birth_date,
      appointee_gender,
      appointee_relation_id,
      appointee_national_id,
      // appointee_permanent_address,
      appointee_present_address,
      appointee_mobile_no,
    } = this.state.currentAppointee;
    const errors = {};
    let isValid = true;

    // if (!appointee_email.trim())
    // errors.appointee_email = "Appointee emaill is required";
    if (!appointee_first_name?.trim()) {
      errors.appointee_first_name = "Appointee first name is required";
      isValid = false;
    }
    if (!appointee_last_name?.trim()) {
      errors.appointee_last_name = "Appointee last name is required";
      isValid = false;
    }
    // if (!appointee_father_name.trim())
    //   errors.appointee_father_name = "Father name is required";
    // if (!appointee_mother_name.trim())
    //   errors.appointee_mother_name = "Mother name is required";
    if (!appointee_birth_date) {
      errors.appointee_birth_date = "Date of birth is required";
      isValid = false;
    } else if (!this.checkAppointeeAge(appointee_birth_date)) {
      errors.appointee_birth_date = "Appointee must be 18+ years old";
      isValid = false;
    }
    if (!appointee_gender) {
      errors.appointee_gender = "Gender is required";
    }
    if (!appointee_relation_id) {
      errors.appointee_relation_id = "Relation is required";
      isValid = false;
    }
    if (!appointee_national_id?.trim()) {
      errors.appointee_national_id = "National ID is required";
      isValid = false;
    }
    if (!appointee_present_address?.trim()) {
      errors.appointee_present_address = "Present address is required";
      isValid = false;
    }
    if (!appointee_mobile_no?.trim()) {
      errors.appointee_mobile_no = "Mobile number is required";
      isValid = false;
    } else if (!/^\d{11}$/.test(appointee_mobile_no)) {
      errors.appointee_mobile_no = "Mobile number must be valid";
      isValid = false;
    }

    this.setState({ errors });
    return isValid;
  };

  checkAppointeeAge = (birthDate) => {
    const today = new Date();
    const birthDateObj = new Date(birthDate);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
    ) {
      age--;
    }

    return age >= 18;
  };

  // Handle form submission to add the nominee

  // handleNomineeSubmit = () => {
  //   const errors = this.validateFields();

  //   if (Object.keys(errors)?.length === 0) {
  //     const { birth_date } = this.state.currentNominee;

  //     // ✅ Call age check before setting new state
  //     this.checkNomineeAge(birth_date);
  //     this.setState((prevState) => ({
  //       nominees: [...prevState.nominees, prevState.currentNominee],
  //       currentNominee: {
  //         nominee_email: "",
  //         nominee_first_name: "",
  //         nominee_last_name: "",
  //         // nominee_father_name: "",
  //         // nominee_mother_name: "",
  //         birth_date: "",
  //         nominee_gender: "",
  //         nominee_national_id: "",
  //         relation_id: "",
  //         // nominee_permanent_address: "",
  //         nominee_present_address: "",
  //         nominee_mobile_no: "",
  //       },
  //       allowNomineeCustom: false,
  //       errors: {},
  //     }));

  //     // Optionally, log the new nominees list
  //     console.log("Nominees: ", this.state.nominees);
  //   } else {
  //     this.setState({ errors }); // Update errors if validation fails
  //   }
  // };
  // handleAppointeeSubmit = () => {
  //   if (!this.appointeeValidateFields()) {
  //     toast.error("Fillup all appointee field with valid information.");
  //     return;
  //   }
  //   this.setState((prevState) => ({
  //     appointees: [...prevState.appointees, prevState.currentAppointee],
  //     errors: {},
  //   }));
  //   toast.success("Added Appointee data.");
  // };

  handleMessageClose = () => {
    this.setState({ message: "", message_type: "" });
  };

  handleDateChange(date) {
    this.setState({
      startDate: date,
    });
  }

  componentDidMount = async () => {
    const location = this.props.location;
    const roleId = Number(this.props.user?.loginuser?.role_id);
    if (roleId === 5 && !location?.state?.ocrDocumentBase64) {
      this.setState({ allowCustom: true });
    }
    if (roleId === 4 || roleId === 8 || roleId === 9) {
      await this.bootstrapLoggedInAgent();
    }
    if (location?.state?.policyId) {
      this.handleEdit(location.state.policyId);
    }
    if (location?.state?.ocrDocumentBase64) {
      const ocrData = this.props.returnCalculator?.calculation || {};
      const cust = ocrData.customer || {};
      const nom = ocrData.nominee || {};

      this.setState({
        files: [
          {
            id: Date.now(),
            file: location.state.ocrDocumentBase64,
            preview: null,
            fileName: location.state.fileName || "OCR_Document.pdf",
            fileType: location.state.fileType || "application/pdf",
            fileSize: (location.state.fileSize / 1024).toFixed(2) + " KB",
            isPDF: true,
          },
        ],
        customer: cust,
        currentNominee: {
          nominee_first_name: nom.first_name || "",
          nominee_last_name: nom.last_name || "",
          birth_date: this.parseDateToYmd(nom.date_of_birth || ""),
          nominee_national_id: nom.national_id || "",
          relation_id: mapRelationToCode(nom.relation || nom.relation_id || ""),
          nominee_mobile_no: nom.mobile || "",
          nominee_present_address:
            (nom.address || nom.present_address || "").trim() ||
            "Same as LA/Proposer",
          nominee_gender: nom.gender || "",
        },
        nominee_nid_value: nom.national_id || "",
      });
    }
  };

  /**
   * Agent (role 4): auto-resolve SAP agencyCode via agentEnquiryLogin using profile mobile.
   */
  bootstrapLoggedInAgent = async () => {
    const raw = (this.props.user?.loginuser?.mobile || "").replace(/\D/g, "");
    let mobile = raw;
    if (raw.length === 10 && raw.startsWith("1")) {
      mobile = "0" + raw;
    } else if (raw.length === 13 && raw.startsWith("880")) {
      mobile = "0" + raw.slice(3);
    }

    if (!/^01\d{9}$/.test(mobile)) {
      this.setState({
        agent_lookup_error:
          "Your profile mobile is missing or invalid. Update your profile to sell policies.",
      });
      return;
    }

    this.setState({ agent_lookup_loading: true, agent_lookup_error: "" });
    const result = await this.fetchAgentByMobile(mobile);
    this.setState({
      agent_lookup_loading: false,
      agent_lookup_error: result.agentError,
      agent_code: result.agentCode,
      agent_name: result.agentName,
      verified_agent_mobile: result.agentCode ? mobile : "",
      allowCustom: !!result.agentCode,
      hasHolderNid: false,
      holder_nid_value: "",
      holder_nid_error: "",
      customer: {},
    });
  };

  fetchAgentByMobile = async (mobile) => {
    const token = localStorage.getItem("authToken");
    const config = {
      headers: {
        Accept: "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    };

    let agentCode = "";
    let agentName = "";
    let agentError = "";
    try {
      const response = await axiosNewInstance.get(
        `api/agentEnquiryLogin/${encodeURIComponent(mobile)}`,
        config
      );
      const data = response?.data || {};
      if (data.Error) {
        agentError = data.Error;
      } else {
        agentCode = data.agencyCode || "";
        agentName = data.agentName || "";
        if (!agentCode) {
          agentError = "Agent code not found for this mobile number.";
        }
      }
    } catch (err) {
      agentError =
        err?.response?.data?.Error ||
        err?.response?.data?.Message ||
        err?.response?.data?.message ||
        "Failed to fetch agent details.";
    }

    return { agentCode, agentName, agentError };
  };

  fetchAgentList = async () => {
    const result = await getFetchData("agent-list");
    if (result?.data?.status === 1 && result?.data?.data?.agents) {
      const formattedAgents =
        result.data.data.agents?.length > 0
          ? result.data.data.agents.map((agent) => ({
            value: agent.id,
            label: agent.login_id?.toString(),
          }))
          : [];
      this.setState({ agentList: formattedAgents });
    } else {
      this.setState({ agentList: [] });
    }
  };

  /**
   * Mobile + Check: Agent Code only (eLife agent enquiry). Does not touch Personal Information.
   *   GET /api/agentEnquiryLogin/{mobile}
   */
  handleAgentLookup = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    const mobile = (this.state.nid_value || "").trim();
    if (!/^01\d{9}$/.test(mobile)) {
      this.setState({
        agent_code: "",
        agent_name: "",
        agent_lookup_error: "Mobile number must be 11 digits and start with 01.",
      });
      return;
    }

    this.setState({
      agent_lookup_loading: true,
      agent_lookup_error: "",
      agent_code: "",
      agent_name: "",
      verified_agent_mobile: "",
    });

    const result = await this.fetchAgentByMobile(mobile);

    const isFromOcr = !!this.props.location?.state?.ocrDocumentBase64;

    this.setState({
      agent_lookup_loading: false,
      agent_lookup_error: result.agentError,
      agent_code: result.agentCode,
      agent_name: result.agentName,
      verified_agent_mobile: result.agentCode ? mobile : "",
      allowCustom: !!result.agentCode,
      ...(isFromOcr ? {} : {
        hasHolderNid: false,
        holder_nid_value: "",
        holder_nid_error: "",
        customer: {},
      }),
    });
  };

  /**
   * NID + Check: local lookup via search-by-nid2. Populates `customer` when found.
   *   POST /api/search-by-nid2  { national_id }
   */
  handleHolderNidLookup = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    const nid = (this.state.holder_nid_value || "").trim();
    if (!nid) {
      this.setState({
        holder_nid_error: "Please enter a National ID.",
        customer: {},
      });
      return;
    }

    this.setState({
      holder_nid_loading: true,
      holder_nid_error: "",
      customer: {},
    });

    const token = localStorage.getItem("authToken");
    const configToken = {
      headers: {
        Accept: "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    };

    const formatDobForDateInput = (dob) => {
      if (dob == null || dob === "") return "";
      const s = String(dob).trim();
      if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
      const slash = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (slash) {
        const [, d, mo, y] = slash;
        return `${y}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
      }
      return s;
    };

    const str = (v) => (v == null || v === "" ? "" : String(v));

    try {
      const response = await axiosNewInstance.post(
        "/api/search-by-nid2",
        { national_id: nid },
        configToken
      );

      const profile = response?.data?.data?.profile;
      if (profile && typeof profile === "object" && Object.keys(profile).length > 0) {
        const genderRaw = (profile.gender || "").toString().toUpperCase();
        const gender =
          genderRaw === "M" || genderRaw === "MALE"
            ? "M"
            : genderRaw === "F" || genderRaw === "FEMALE"
              ? "F"
              : "";

        const customer = {
          first_name: profile.first_name ?? "",
          last_name: profile.last_name ?? "",
          gender,
          date_of_birth: formatDobForDateInput(profile.date_of_birth),
          mobile: profile.mobile ?? "",
          email: profile.email ?? "",
          national_id: profile.national_id ?? nid,
          present_address:
            profile.present_address ?? profile.address ?? "",
          parmanent_address:
            profile.parmanent_address ?? profile.address ?? "",
          father_name: profile.father_name ?? "",
          mother_name: profile.mother_name ?? "",
          spouse_name: profile.spouse_name ?? "",
          place_of_birth: profile.place_of_birth ?? "",
          education: str(profile.education),
          occupation: str(profile.occupation),
          annual_income: str(profile.annual_income),
          nationality: profile.nationality ?? "",
          id: profile.id,
        };

        this.setState({
          customer,
          holder_nid_loading: false,
          holder_nid_error: "",
          /* Found — show the read-only customer block; hide manual form. */
          allowCustom: false,
        });
      } else {
        this.setState({
          customer: {},
          holder_nid_loading: false,
          holder_nid_error: "No record found. You can enter details manually.",
          /* Not found — keep manual form open and preserve typed NID. */
          allowCustom: true,
        });
      }
    } catch (error) {
      if (
        error?.response?.data?.status === 0 &&
        error?.response?.data?.message === "User not authenticated"
      ) {
        localStorage.removeItem("authToken");
        this.props.history.push("/login");
      }
      this.setState({
        customer: {},
        holder_nid_loading: false,
        holder_nid_error:
          error?.response?.data?.message || "Failed to lookup National ID.",
        allowCustom: true,
      });
    }
  };

  handleVerification = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("authToken");

    if (!token) {
      console.error("No token found, please log in first.");
      return;
    }

    const configToken = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    let nid_value = this.state.nid_value;
    try {
      const response = await axiosNewInstance.post(
        "/api-app/find-customer",
        { national_id: nid_value },
        configToken
      );

      const isCustomerExit = response?.data?.data?.customer;

      if (isCustomerExit && typeof isCustomerExit === "object") {
        if (Object.keys(isCustomerExit)?.length > 0) {
          this.setState({ customer: isCustomerExit });

          this.setState({ allowCustom: false });
        } else {
          // this.setState({ nid_value: "" });
          this.setState({ customer: {} });
          this.setState({ allowCustom: true });
        }
      } else {
        // this.setState({ nid_value: "" });
        this.setState({ customer: {} });

        this.setState({ allowCustom: true });
      }
    } catch (error) {
      // this.setState({ nid_value: "" });
      this.setState({ customer: {} });

      this.setState({ allowCustom: true });
      if (
        error.response?.data?.status === 0 &&
        error?.response?.data?.message === "User not authenticated"
      ) {
        localStorage.removeItem("authToken");
        this.props.history.push("/login");
      }
      // toast.error(error.response?.data?.message)
      this.setState({
        verificationError:
          error.response?.data?.message || "Something went wrong",
      });
      console.error("Error fetching customer:", error);
    } finally {
      // let customerData = {
      //   data: {
      //     customer: {
      //       id: 1110,
      //       first_name: "dfdf",
      //       last_name: "fdfd",
      //       gender: "",
      //       date_of_birth: "1995-06-06",
      //       national_id: "2389947105",
      //       nationality: "dfaf",
      //       father_name: "dfaf",
      //       mother_name: "dfaf",
      //       spouse_name: "dfaf",
      //       parmanent_address: "dfaf",
      //       present_address: "dfaf",
      //       place_of_birth: "dfa",
      //       mobile: "01827998877",
      //       email: "mail@gmail.com",
      //       education: "dfdfa",
      //       occupation: "dfdf",
      //       annual_income: "3333333",
      //       customer_id: null,
      //       otp: null,
      //       status: 1,
      //       created_by: 1,
      //       updated_by: null,
      //       deleted_by: null,
      //       created_at: "2025-03-17 11:23:48",
      //       updated_at: "2025-03-17 11:23:48",
      //       deleted_at: null,
      //     },
      //   },
      //   message: "Success",
      //   status: 1,
      // };
      // this.setState({ customer: customerData?.data?.customer });
    }
  };
  handleNomineeVerification = async (e) => {
    e.preventDefault();
    let nid_value = this.state.nominee_nid_value;
    this.setState({ nominees: [] });
    const token = localStorage.getItem("authToken");

    if (!token) {
      console.error("No token found, please log in first.");
      return;
    }

    const configToken = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await axiosNewInstance.post(
        "/api/search-by-nid2",
        { national_id: nid_value },
        configToken
      );

      const matchedNominee = response?.data?.data?.profile;
      // const isCustomerExit = response?.data?.data?.profile;
      const isCustomerExit = {
        nominee_email: matchedNominee?.email ?? "",
        nominee_first_name: matchedNominee?.first_name ?? "",
        nominee_last_name: matchedNominee?.last_name ?? "",
        // nominee_father_name: "",
        // nominee_mother_name: "",
        birth_date: matchedNominee?.date_of_birth ?? "",
        nominee_gender: matchedNominee?.gender ?? "",
        nominee_national_id: matchedNominee?.national_id ?? nid_value ?? "",
        relation_id: matchedNominee?.relation_id ?? "",
        // nominee_permanent_address: "",
        nominee_present_address: matchedNominee?.address ?? "",
        nominee_mobile_no: matchedNominee?.mobile ?? "",
      };

      if (isCustomerExit && typeof isCustomerExit === "object") {
        if (Object.keys(isCustomerExit)?.length > 0) {
          // this.setState({ nominees: [isCustomerExit] });
          this.setState({
            currentNominee: {
              ...isCustomerExit,
            },
          });
          this.setState({ allowNomineeCustom: true });
        } else {
          this.setState((prev) => ({
            customer: {},
            allowNomineeCustom: true,
            currentNominee: {
              ...prev.currentNominee,
              nominee_national_id: nid_value,
              nominee_email: "",
              nominee_first_name: "",
              nominee_last_name: "",
              birth_date: "",
              nominee_gender: "",
              relation_id: "",
              nominee_present_address: "",
              nominee_mobile_no: "",
            },
          }));
        }
      } else {
        this.setState((prev) => ({
          allowNomineeCustom: true,
          currentNominee: {
            ...prev.currentNominee,
            nominee_national_id: nid_value,
            nominee_email: "",
            nominee_first_name: "",
            nominee_last_name: "",
            birth_date: "",
            nominee_gender: "",
            relation_id: "",
            nominee_present_address: "",
            nominee_mobile_no: "",
          },
        }));
      }
    } catch (error) {
      this.setState((prev) => ({
        allowNomineeCustom: true,
        currentNominee: {
          ...prev.currentNominee,
          nominee_national_id: prev.nominee_nid_value,
          nominee_email: "",
          nominee_first_name: "",
          nominee_last_name: "",
          birth_date: "",
          nominee_gender: "",
          relation_id: "",
          nominee_present_address: "",
          nominee_mobile_no: "",
        },
      }));

      if (
        error.response?.data?.status === 0 &&
        error?.response?.data?.message === "User not authenticated"
      ) {
        localStorage.removeItem("authToken");
        this.props.history.push("/login");
      }

      this.setState({
        verificationError:
          error.response?.data?.message || "Something went wrong",
      });
      console.error("Error fetching customer:", error);
    }
  };
  handleAppointeeVerification = async (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      appointees: [],
    }));
    let nid_value = this.state.appointee_nid_value;
    this.setState({ appointee: [] });
    const token = localStorage.getItem("authToken");

    if (!token) {
      console.error("No token found, please log in first.");
      return;
    }

    const configToken = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await axiosNewInstance.post(
        "/api/search-by-nid2",
        { national_id: nid_value },
        configToken
      );

      const isCustomerExit = response?.data?.data?.profile;
      // console.log("isCustomerExit 33333333333333333",isCustomerExit, isCustomerExit && typeof isCustomerExit === "object")
      if (isCustomerExit && typeof isCustomerExit === "object") {
        if (Object.keys(isCustomerExit)?.length > 0) {
          let customerData = isCustomerExit;
          let currentAppointeeNew = {
            appointee_email: customerData?.email,
            appointee_first_name: customerData?.first_name,
            appointee_last_name: customerData?.last_name,
            appointee_birth_date: customerData?.date_of_birth,
            appointee_gender: customerData?.gender,
            appointee_national_id: customerData?.national_id,
            appointee_present_address: customerData?.address, /// it might be change later don't forget 333333333333333333333333
            appointee_mobile_no: customerData?.mobile,
          };
          this.setState((prevState) => ({
            currentAppointee: {
              ...prevState.currentAppointee,
              ...currentAppointeeNew,
            },
          }));

          this.setState({ allowAppointeeCustom: true });
        } else {
          // this.setState({ nid_value: "" });
          // this.setState({ appointee: [] });
          this.setState({ allowAppointeeCustom: true });
          this.setState({
            currentAppointee: {
              appointee_national_id: this.state.appointee_nid_value,
              appointee_email: "",
              appointee_first_name: "",
              appointee_last_name: "",
              appointee_birth_date: "",
              appointee_gender: "",
              appointee_relation_id: "",
              appointee_present_address: "",
              appointee_mobile_no: "",
            },
          });
        }
      } else {
        // this.setState({ nid_value: "" });
        // this.setState({ appointee: [] });

        this.setState({ allowAppointeeCustom: true });
        this.setState({
          currentAppointee: {
            appointee_national_id: this.state.appointee_nid_value,
            appointee_email: "",
            appointee_first_name: "",
            appointee_last_name: "",
            appointee_birth_date: "",
            appointee_gender: "",
            appointee_relation_id: "",
            appointee_present_address: "",
            appointee_mobile_no: "",
          },
        });
      }
    } catch (error) {
      // this.setState({ nid_value: "" });
      // this.setState({ appointee: [] });

      this.setState({ allowAppointeeCustom: true });
      if (
        error.response?.data?.status === 0 &&
        error?.response?.data?.message === "User not authenticated"
      ) {
        localStorage.removeItem("authToken");
        this.props.history.push("/login");
      }
      // toast.error(error.response?.data?.message)
      this.setState({
        verificationError:
          error.response?.data?.message || "Something went wrong",
      });
      console.error("Error fetching customer:", error);
    } finally {
      // let customerResponseData = {
      //   data: {
      //     profile: {
      //       national_id: "2698879312783",
      //       first_name: "Momo",
      //       last_name: "Hassan",
      //       date_of_birth: "1982-04-06",
      //       mobile: "01712555327",
      //       email: "lic.momobd@gmail.com",
      //       address: "Flat 10C CHA 89/4 89/5",
      //       profile_type: "customer",
      //     },
      //   },
      //   message: "Success",
      //   status: 1,
      // };
      // this.setState({ allowAppointeeCustom: true });
      // let customerData = customerResponseData?.data?.profile;
      // let currentAppointeeNew = {
      //   appointee_email: customerData?.email,
      //   appointee_first_name: customerData?.first_name,
      //   appointee_last_name: customerData?.last_name,
      //   appointee_birth_date: customerData?.date_of_birth,
      //   appointee_national_id: customerData?.national_id,
      //   appointee_present_address: customerData?.address, /// it might be change later don't forget 333333333333333333333333
      //   appointee_mobile_no: customerData?.mobile,
      // };
      // this.setState((prevState) => ({
      //   currentAppointee: {
      //     ...prevState.currentAppointee,
      //     ...currentAppointeeNew,
      //   },
      // }));
    }
  };

  handleSubmit = (allowDraft = false, allowEdit = false) => {
    const {
      formdata,
      customer,
      // appointees,
      // allowNomineeCustom,
      allowAppointeeCustom,
      currentAppointee,
    } = this.state;
    const user = this.props?.user;
    const calCulatorData = this.props?.returnCalculator?.calculation;
    // New purchase = no customer/policy id (NID lookup only prefills the form).
    const isUpdatingDraft = Boolean(
      this.state.isEditing && calCulatorData?.id
    );
    // ========================== checking nominee submit
    const errors = this.validateFields();
    // console.log("this.state?.files?.length  3333: ", this.state?.files[0]?.file, this.state?.document, typeof this.state?.document );
    // Check if we have either a new file upload or an existing document
    const hasNewFile = Boolean(this.state.files[0]?.file);
    const hasExistingDocument = Boolean(this.state?.document);

    // ---------------------------------------------- draft submitted functionality start
    if (allowDraft && allowEdit) {
      // if (!nomineeData?.length > 0) {
      //   toast.error("Please save nominee information.");
      //   return;
      // }

      const question_answer = {
        policy_holder_medical_practitioner:
          formdata.policy_holder_medical_practitioner === 1 ? 1 : 0,
        policy_holder_medical_practitioner_details:
          formdata.policy_holder_medical_practitioner === 1
            ? this.policy_holder_medical_practitioner_details?.value
            : "",
        policy_holder_admitted_hospital:
          formdata.policy_holder_admitted_hospital === 1 ? 1 : 0,
        policy_holder_admitted_hospital_details:
          formdata.policy_holder_admitted_hospital === 1
            ? this.policy_holder_admitted_hospital_details?.value
            : "",
        policy_holder_remained_absent:
          formdata.policy_holder_remained_absent === 1 ? 1 : 0,
        policy_holder_remained_absent_details:
          formdata.policy_holder_remained_absent === 1
            ? this.policy_holder_remained_absent_details?.value
            : "",
        policy_holder_suffering_ailments_pertaining:
          formdata.policy_holder_suffering_ailments_pertaining === 1 ? 1 : 0,
        policy_holder_suffering_ailments_pertaining_details:
          formdata.policy_holder_suffering_ailments_pertaining === 1
            ? this.policy_holder_suffering_ailments_pertaining_details?.value
            : "",
        policy_holder_suffered_diabetes_others:
          formdata.policy_holder_suffered_diabetes_others === 1 ? 1 : 0,
        policy_holder_suffered_diabetes_others_details:
          formdata.policy_holder_suffered_diabetes_others === 1
            ? this.policy_holder_suffered_diabetes_others_details?.value
            : "",
        policy_holder_bodily_defect_deformity:
          formdata.policy_holder_bodily_defect_deformity === 1 ? 1 : 0,
        policy_holder_bodily_defect_deformity_details:
          formdata.policy_holder_bodily_defect_deformity === 1
            ? this.policy_holder_bodily_defect_deformity_details?.value
            : "",
        policy_holder_accident_injury:
          formdata.policy_holder_accident_injury === 1 ? 1 : 0,
        policy_holder_accident_injury_details:
          formdata.policy_holder_accident_injury === 1
            ? this.policy_holder_accident_injury_details?.value
            : "",
        policy_holder_used_alcoholic_others:
          formdata.policy_holder_used_alcoholic_others === 1 ? 1 : 0,
        policy_holder_used_alcoholic_others_details:
          formdata.policy_holder_used_alcoholic_others === 1
            ? this.policy_holder_used_alcoholic_others_details?.value
            : "",
        policy_holder_good_health:
          formdata.policy_holder_good_health === 1 ? 1 : 0,
        policy_holder_good_health_details:
          formdata.policy_holder_good_health === 1
            ? this.policy_holder_good_health_details?.value
            : "",
        policy_holder_aids_hepatitis:
          formdata.policy_holder_aids_hepatitis === 1 ? 1 : 0,
        policy_holder_aids_hepatitis_details:
          formdata.policy_holder_aids_hepatitis === 1
            ? this.policy_holder_aids_hepatitis_details?.value
            : "",
        blood: this.policy_holder_blood_information?.value,
        pulse_rate: this.policy_holder_pulse_rate?.value,
        height: this.policy_holder_height?.value,
        weight: this.policy_holder_weight?.value,
        smoker_status: this.policy_holder_smoker_status?.value,
      };

      // // First convert the file
      // let documentss = "";
      // if (this.state.files[0]?.file) {
      //   documentss = this.convertFileToBase64(this.state.files[0].file);
      // }
      // console.log("documents 2222222222222222222222", documentss);
      const { critical_illness, accidental_cover, hcbSa } =
        calCulatorData?.payload || {};
      const hasHcb = Boolean(hcbSa && hcbSa !== "0" && hcbSa !== 0);
      const hasCi = Boolean(critical_illness && critical_illness !== "0" && critical_illness !== 0);
      const hasAcc = Boolean(accidental_cover && accidental_cover !== "0" && accidental_cover !== 0);
      const riderCount = [hasHcb, hasCi, hasAcc].filter(Boolean).length;
      const personalInfo =
        customer && Object.keys(customer).length > 0
          ? {
            customer_first_name: customer?.first_name,
            customer_last_name: customer?.last_name,
            date_of_birth: this.parseDateToYmd(customer?.date_of_birth),
            gender: (() => {
              const g = (customer.gender ?? "")
                .toString()
                .trim()
                .toUpperCase();
              if (g === "M" || g === "MALE") return "M";
              if (g === "F" || g === "FEMALE") return "F";
              return "";
            })(),
            national_id:
              customer?.national_id ||
              this.policy_holder_national_id?.value ||
              this.state.holder_nid_value ||
              null,
            nationality: customer?.nationality,
            place_of_birth: customer?.place_of_birth,
            annual_income: customer?.annual_income,
            occupation: customer?.occupation,
            education: customer?.education,
            father_name: customer?.father_name,
            mother_name: customer?.mother_name,
            email_address: customer?.email,
            mobile_no: customer?.mobile,
            spouse_name: customer?.spouse_name ?? "",
            permanent_address: customer?.parmanent_address,
            present_address: customer?.present_address,
            customer_id: customer?.id,
          }
          : {
            customer_first_name: this.policy_holder_first_name?.value ?? null,
            customer_last_name: this.policy_holder_last_name?.value ?? null,
            date_of_birth: this.parseDateToYmd(this.policy_holder_dob?.value),
            gender: this.policy_holder_gender?.value ?? null,
            national_id:
              this.policy_holder_national_id?.value ??
              this.state.holder_nid_value ??
              null,
            nationality: this.policy_holder_nationality?.value ?? null,
            place_of_birth: this.policy_holder_place_of_birth?.value ?? null,
            annual_income: this.policy_holder_annual_income?.value ?? null,
            occupation: this.policy_holder_occupation?.value ?? null,
            education: this.policy_holder_education?.value ?? null,
            father_name: this.policy_holder_father_name?.value ?? null,
            mother_name: this.policy_holder_mother_name?.value ?? null,
            email_address: this.policy_holder_email?.value ?? null,
            mobile_no: this.policy_holder_mobile_number?.value ?? null,
            spouse_name: this.policy_holder_spouse?.value ?? null,
            present_address:
              this.policy_holder_present_address?.value ?? null,
            customer_id: null,
          };
      if (Object.keys(personalInfo)?.length > 0) {
        if (!this.genderDobMatchesCalculator(personalInfo, calCulatorData)) {
          toast.error("You should match nid & gender!");
          return;
        }

        const errors = this.validateDraftSaveConfirmFields(personalInfo);
        if (Object.keys(errors)?.length > 0) {
          toast.error("Please check Customer Information fields!");
          this.setState({
            validator: { ...this.state.validator, ...errors },
          });
          return;
        }
      }
      const policy_details = {
        customer_age: calCulatorData?.age,
        policy_id: parseInt(calCulatorData?.payload?.policy || calCulatorData?.policyId),
        mode: calCulatorData?.mode,
        term: parseInt(calCulatorData?.payload?.term || calCulatorData?.term || 0),
        premium_paying_term: String(
          calCulatorData?.payload?.premiumPayingTerm || calCulatorData?.term || ""
        ),
        accidental_coverage:
          calCulatorData?.accidental_cover === "1"
            ? "Yes"
            : calCulatorData?.accidental_cover === "0"
              ? "No"
              : null,
        sum_assured: String(calCulatorData?.sum_assured || ""),
        monthly_premium: String(calCulatorData?.premium_amount || ""),
        date_of_commencement: this.parseDateToYmd(calCulatorData?.date_of_commencement) || new Date().toISOString().slice(0, 10),
        documents: this.state.files[0]?.file || "",
        status: 0, // Always draft status for this case
        customer_policy_id: isUpdatingDraft ? calCulatorData.id : null,
        ci_rider_sa: calCulatorData?.payload?.cirSa || "",
        hcb_rider_sa: calCulatorData?.payload?.hcbSa || "",
        scb_rider_sa: calCulatorData?.payload?.scbSa || "",
        term_rider_sa: calCulatorData?.payload?.trSa || "",
        pwb_flag: calCulatorData?.payload?.pwbFlag || "Y",
        prop_gender: calCulatorData?.payload?.propGender || "M",
        lf2_cir_sa: calCulatorData?.payload?.lf2CirSa || "0",
        critical_illness_rider:
          calCulatorData?.payload?.critical_illness === "0"
            ? "No"
            : calCulatorData?.payload?.critical_illness === "1"
              ? "Yes"
              : calCulatorData?.payload?.critical_illness === "2"
                ? "Other"
                : null,
        insurance_rider: riderCount > 0 ? String(riderCount) : null,
        boc_amount:
          user?.loginuser?.role_id === 3 ? calCulatorData.premium_amount : null,
        transaction_id:
          user?.loginuser?.role_id === 3 ? this.state.transaction_id : null,
        agent_code:
          user?.loginuser?.role_id === 5
            ? null
            : [4, 8, 9].includes(Number(user?.loginuser?.role_id))
              ? this.state.agent_code || null
              : user?.loginuser?.role_id === 2
                ? this.state.agent_code || this.state.agency_code || null
                : this.state.agent_code || null,
        agent_mobile:
          user?.loginuser?.role_id === 5
            ? null
            : this.state.verified_agent_mobile || null,
      };
      const nomineeData = this.generatePayload();

      const appointeePayload = allowAppointeeCustom
        ? {
          email_address: currentAppointee?.appointee_email ?? null,
          first_name: currentAppointee.appointee_first_name ?? null,
          last_name: currentAppointee.appointee_last_name ?? null,
          birth_date: currentAppointee.appointee_birth_date ?? null,
          gender: currentAppointee.appointee_gender ?? null,
          appointee_national_id: this.state.appointee_nid_value ?? null,
          relation: currentAppointee.appointee_relation_id ?? null,
          present_address: currentAppointee.appointee_present_address ?? null,
          mobile_no: currentAppointee.appointee_mobile_no ?? null,
        }
        : null;

      const userFormData = {
        customer_details: personalInfo,
        nominee_details: nomineeData,
        policy_details: policy_details,
        questions_answers: question_answer,
        appointee: appointeePayload,
      };

      // console.log("File base64 data:", this.state.files[0]?.file);
      // console.log("Full form data:", userFormData);

      this.handlePolicySave(userFormData);
      return;
    }
    // ---------------------------------------------- draft submitted functionality end

    if (!hasNewFile && !hasExistingDocument) {
      toast.error("Please upload the required documents.");
      return;
    }
    if ([4, 8, 9].includes(Number(user?.loginuser?.role_id)) && !this.state.agent_code) {
      toast.error(
        "Could not load your agent code. Check your profile mobile or try again later."
      );
      return;
    }
    const isCustomerUser = Number(user?.loginuser?.role_id) === 5;
    const isAgentUser = [4, 8, 9].includes(Number(user?.loginuser?.role_id));
    if (
      !isCustomerUser &&
      !isAgentUser &&
      Number(user?.loginuser?.role_id) !== 3 &&
      (!this.state.agent_code ||
        !this.state.verified_agent_mobile ||
        (this.state.nid_value || "").trim() !== (this.state.verified_agent_mobile || "").trim())
    ) {
      toast.error("Please verify your agent before submitting.");
      return;
    }
    if (
      user?.loginuser?.role_id === 3 &&
      !this.state.agency_code &&
      !this.state.transaction_id
    ) {
      toast.error("Please select the agency code and transaction id.");
      return;
    }

    if (Object.keys(errors)?.length === 0) {
      const { birth_date } = this.state.currentNominee;

      // ✅ Call age check before setting new state
      this.checkNomineeAge(birth_date);

      // Optionally, log the new nominees list
      console.log("Nominees: ", this.state.nominees);
    } else {
      this.setState({ errors }); // Update errors if validation fails
      toast.error("Please check nominee fields.");
      return;
    }
    // ==========================
    const nomineeData = this.generatePayload();
    // ========================== checking appointees submit
    if (allowAppointeeCustom) {
      if (!this.appointeeValidateFields()) {
        toast.error("Fillup all appointee field with valid information.");
        return;
      }
    }
    const appointeePayload = allowAppointeeCustom
      ? {
        email_address: currentAppointee?.appointee_email ?? "",
        first_name: currentAppointee.appointee_first_name,
        last_name: currentAppointee.appointee_last_name,
        birth_date: currentAppointee.appointee_birth_date,
        gender: currentAppointee.appointee_gender,
        // national_id: currentAppointee.appointee_national_id,
        appointee_national_id: this.state.appointee_nid_value,
        relation: currentAppointee.appointee_relation_id,
        present_address: currentAppointee.appointee_present_address,
        mobile_no: currentAppointee.appointee_mobile_no,
      }
      : null;
    const personalInfo =
      customer && Object.keys(customer).length > 0
        ? {
          customer_first_name: customer?.first_name,
          customer_last_name: customer?.last_name,
          date_of_birth: this.parseDateToYmd(customer?.date_of_birth),
          gender: (() => {
            const g = (customer.gender ?? "")
              .toString()
              .trim()
              .toUpperCase();
            if (g === "M" || g === "MALE") return "M";
            if (g === "F" || g === "FEMALE") return "F";
            return "";
          })(),
          national_id:
            customer?.national_id ||
            this.policy_holder_national_id?.value ||
            this.state.holder_nid_value ||
            null,
          nationality: customer?.nationality,
          place_of_birth: customer?.place_of_birth,
          annual_income: customer?.annual_income,
          occupation: customer?.occupation,
          education: customer?.education,
          father_name: customer?.father_name,
          mother_name: customer?.mother_name,
          email_address: customer?.email,
          mobile_no: customer?.mobile,
          spouse_name: customer?.spouse_name ?? "",
          permanent_address: customer?.parmanent_address,
          present_address: customer?.present_address,
          customer_id: customer?.id,
        }
        : {
          customer_first_name: this.policy_holder_first_name?.value,
          customer_last_name: this.policy_holder_last_name?.value,
          date_of_birth: this.parseDateToYmd(this.policy_holder_dob?.value),
          gender: this.policy_holder_gender?.value,
          national_id:
            this.policy_holder_national_id?.value ??
            this.state.holder_nid_value ??
            null,
          nationality: this.policy_holder_nationality?.value,
          place_of_birth: this.policy_holder_place_of_birth?.value,
          annual_income: this.policy_holder_annual_income?.value,
          occupation: this.policy_holder_occupation?.value,
          education: this.policy_holder_education?.value,
          father_name: this.policy_holder_father_name?.value,
          mother_name: this.policy_holder_mother_name?.value,
          email_address: this.policy_holder_email?.value,
          mobile_no: this.policy_holder_mobile_number?.value,
          spouse_name: this.policy_holder_spouse?.value,
          // permanent_address: this.policy_holder_parmanent_address?.value,
          present_address: this.policy_holder_present_address?.value,
          customer_id: null,
        };
    if (Object.keys(personalInfo)?.length > 0) {
      if (!this.genderDobMatchesCalculator(personalInfo, calCulatorData)) {
        toast.error(
          "Gender and date of birth must match the premium calculator."
        );
        return;
      }

      const errors = this.validateSaveConfirmFields(personalInfo);
      if (Object.keys(errors)?.length > 0) {
        toast.error("Please check Customer Information fields!");
        this.setState({
          validator: { ...this.state.validator, ...errors },
        });
        return;
      }
    }
    // If both allowDraft and allowEdit are true, bypass validation and directly save

    const question_answer = {
      policy_holder_medical_practitioner:
        formdata.policy_holder_medical_practitioner === 1 ? 1 : 0,
      policy_holder_medical_practitioner_details:
        formdata.policy_holder_medical_practitioner === 1
          ? this.policy_holder_medical_practitioner_details?.value
          : "",
      policy_holder_admitted_hospital:
        formdata.policy_holder_admitted_hospital === 1 ? 1 : 0,
      policy_holder_admitted_hospital_details:
        formdata.policy_holder_admitted_hospital === 1
          ? this.policy_holder_admitted_hospital_details?.value
          : "",
      policy_holder_remained_absent:
        formdata.policy_holder_remained_absent === 1 ? 1 : 0,
      policy_holder_remained_absent_details:
        formdata.policy_holder_remained_absent === 1
          ? this.policy_holder_remained_absent_details?.value
          : "",
      policy_holder_suffering_ailments_pertaining:
        formdata.policy_holder_suffering_ailments_pertaining === 1 ? 1 : 0,
      policy_holder_suffering_ailments_pertaining_details:
        formdata.policy_holder_suffering_ailments_pertaining === 1
          ? this.policy_holder_suffering_ailments_pertaining_details?.value
          : "",
      policy_holder_suffered_diabetes_others:
        formdata.policy_holder_suffered_diabetes_others === 1 ? 1 : 0,
      policy_holder_suffered_diabetes_others_details:
        formdata.policy_holder_suffered_diabetes_others === 1
          ? this.policy_holder_suffered_diabetes_others_details?.value
          : "",
      policy_holder_bodily_defect_deformity:
        formdata.policy_holder_bodily_defect_deformity === 1 ? 1 : 0,
      policy_holder_bodily_defect_deformity_details:
        formdata.policy_holder_bodily_defect_deformity === 1
          ? this.policy_holder_bodily_defect_deformity_details?.value
          : "",
      policy_holder_accident_injury:
        formdata.policy_holder_accident_injury === 1 ? 1 : 0,
      policy_holder_accident_injury_details:
        formdata.policy_holder_accident_injury === 1
          ? this.policy_holder_accident_injury_details?.value
          : "",
      policy_holder_used_alcoholic_others:
        formdata.policy_holder_used_alcoholic_others === 1 ? 1 : 0,
      policy_holder_used_alcoholic_others_details:
        formdata.policy_holder_used_alcoholic_others === 1
          ? this.policy_holder_used_alcoholic_others_details?.value
          : "",
      policy_holder_good_health:
        formdata.policy_holder_good_health === 1 ? 1 : 0,
      policy_holder_good_health_details:
        formdata.policy_holder_good_health === 1
          ? this.policy_holder_good_health_details?.value
          : "",
      policy_holder_aids_hepatitis:
        formdata.policy_holder_aids_hepatitis === 1 ? 1 : 0,
      policy_holder_aids_hepatitis_details:
        formdata.policy_holder_aids_hepatitis === 1
          ? this.policy_holder_aids_hepatitis_details?.value
          : "",
      blood: this.policy_holder_blood_information?.value,
      pulse_rate: this.policy_holder_pulse_rate?.value,
      height: this.policy_holder_height?.value,
      weight: this.policy_holder_weight?.value,
      smoker_status: this.policy_holder_smoker_status?.value,
    };
    const { critical_illness, accidental_cover, hcbSa } =
      calCulatorData?.payload || {};
    const hasHcb = Boolean(hcbSa && hcbSa !== "0" && hcbSa !== 0);
    const hasCi = Boolean(critical_illness && critical_illness !== "0" && critical_illness !== 0);
    const hasAcc = Boolean(accidental_cover && accidental_cover !== "0" && accidental_cover !== 0);
    const riderCount = [hasHcb, hasCi, hasAcc].filter(Boolean).length;
    const policy_details = {
      customer_age: calCulatorData?.age,
      policy_id: parseInt(calCulatorData?.payload?.policy || calCulatorData?.policyId),
      mode: calCulatorData?.mode,
      term: parseInt(calCulatorData?.payload?.term || calCulatorData?.term || 0),
      accidental_coverage:
        calCulatorData?.accidental_cover === "1"
          ? "Yes"
          : calCulatorData?.accidental_cover === "0"
            ? "No"
            : null,
      premium_paying_term: parseInt(calCulatorData?.payload?.premiumPayingTerm || calCulatorData?.term || 0),
      sum_assured: String(calCulatorData?.sum_assured || ""),
      monthly_premium: String(calCulatorData?.premium_amount || ""),
      date_of_commencement: this.parseDateToYmd(calCulatorData?.date_of_commencement) || new Date().toISOString().slice(0, 10),
      documents: this.state.files[0]?.file || "",
      status: allowDraft ? 0 : 1,
      customer_policy_id: isUpdatingDraft ? calCulatorData.id : null,
      ci_rider_sa: calCulatorData?.payload?.cirSa || "",
      hcb_rider_sa: calCulatorData?.payload?.hcbSa || "",
      scb_rider_sa: calCulatorData?.payload?.scbSa || "",
      term_rider_sa: calCulatorData?.payload?.trSa || "",
      pwb_flag: calCulatorData?.payload?.pwbFlag || "Y",
      prop_gender: calCulatorData?.payload?.propGender || "M",
      lf2_cir_sa: calCulatorData?.payload?.lf2CirSa || "0",
      critical_illness_rider:
        calCulatorData?.payload?.critical_illness === "0"
          ? "No"
          : calCulatorData?.payload?.critical_illness === "1"
            ? "Yes"
            : calCulatorData?.payload?.critical_illness === "2"
              ? "Other"
              : null,
      insurance_rider: riderCount > 0 ? String(riderCount) : "0",
      boc_amount:
        user?.loginuser?.role_id === 3 ? calCulatorData.premium_amount : "",
      transaction_id:
        user?.loginuser?.role_id === 3 ? this.state.transaction_id : "",
      agent_code:
        user?.loginuser?.role_id === 5
          ? ""
          : [4, 8, 9].includes(Number(user?.loginuser?.role_id))
            ? this.state.agent_code || ""
            : user?.loginuser?.role_id === 2
              ? this.state.agent_code || this.state.agency_code || ""
              : this.state.agent_code || "",
      agent_mobile:
        user?.loginuser?.role_id === 5
          ? ""
          : this.state.verified_agent_mobile || "",
    };

    const userFormData = {
      customer_details: personalInfo,
      nominee_details: nomineeData,
      policy_details: policy_details,
      questions_answers: question_answer,
      appointee: appointeePayload,
    };

    this.handlePolicySave(userFormData);
  };

  // Generate Payload from State
  generatePayload = () => {
    const { currentNominee } = this.state;

    // Create an array with the current nominee if it exists
    const nomineesArray =
      currentNominee && Object.keys(currentNominee).length > 0
        ? [currentNominee]
        : [];
    const payload = nomineesArray?.map((n) => ({
      nominee_first_name: n.nominee_first_name + " " + n.nominee_last_name,
      nominee_last_name: n.nominee_last_name,
      birth_date: this.parseDateToYmd(n.birth_date),
      relation: mapRelationToCode(n.relation_id || n.relation || ""),
      nominee_gender: n.nominee_gender,
      nominee_national_id: n.nominee_national_id,
      nominee_father_name: n.nominee_father_name || null,
      nominee_mother_name: n.nominee_mother_name || null,
      nominee_spouse_name: n.nominee_spouse_name || null, // Keep null if not needed
      nominee_present_address: n.nominee_present_address,
      nominee_mobile_no: n.nominee_mobile_no,
      nominee_email: n.nominee_email,
    }));

    return payload;
  };

  handleRadio = (name, value) => {
    var question = {};
    if (name == "policy_holder_medical_practitioner") {
      question = { policy_holder_medical_practitioner: value };
    } else if (name == "policy_holder_admitted_hospital") {
      question = { policy_holder_admitted_hospital: value };
    } else if (name == "policy_holder_remained_absent") {
      question = { policy_holder_remained_absent: value };
    } else if (name == "policy_holder_suffering_ailments_pertaining") {
      question = { policy_holder_suffering_ailments_pertaining: value };
    } else if (name == "policy_holder_suffered_diabetes_others") {
      question = { policy_holder_suffered_diabetes_others: value };
    } else if (name == "policy_holder_bodily_defect_deformity") {
      question = { policy_holder_bodily_defect_deformity: value };
    } else if (name == "policy_holder_accident_injury") {
      question = { policy_holder_accident_injury: value };
    } else if (name == "policy_holder_used_alcoholic_others") {
      question = { policy_holder_used_alcoholic_others: value };
    } else if (name == "policy_holder_good_health") {
      question = { policy_holder_good_health: value };
    } else if (name == "policy_holder_aids_hepatitis") {
      question = { policy_holder_aids_hepatitis: value };
    } else {
      question = {};
    }

    this.setState({
      formdata: {
        ...this.state.formdata,
        ...question,
      },
    });
  };

  handlePorichoy = (e) => {
    const validation = {};
    const value = e.target.value;
    const numbersOnly = value.replace(/\D/g, ""); /* keep digits only */
    const resetVerification = {
      agent_code: "",
      agent_name: "",
      verified_agent_mobile: "",
      agent_lookup_error: "",
    };

    if (!/^\d*$/.test(value)) {
      validation.policy_holder_nid = "Mobile number can only contain numbers";
      this.setState({
        validator: { ...this.state.validator, ...validation },
        nid_value: numbersOnly,
        ...resetVerification,
      });
      return false;
    }

    /* BD mobile: 11 digits starting with 01 */
    if (numbersOnly.length === 11 && /^01\d{9}$/.test(numbersOnly)) {
      validation.policy_holder_mobile = "";
      validation.policy_holder_nid = "";
      this.setState({
        validator: { ...this.state.validator, ...validation },
        nid_value: numbersOnly,
        ...resetVerification,
      });
      return true;
    }

    validation.policy_holder_nid =
      "Mobile number must be 11 digits and start with 01.";
    this.setState({
      validator: { ...this.state.validator, ...validation },
      nid_value: numbersOnly,
      ...resetVerification,
    });
    return false;
  };
  handleNonmineePorichoy = (e) => {
    const value = e.target.value;
    const errors = {};

    // Allow only digits
    if (!/^\d*$/.test(value)) {
      errors.nominee_national_id = "NID can only contain numbers";
      this.setState({
        errors: { ...this.state.errors, ...errors },
        nominee_nid_value: value.replace(/\D/g, ""), // Remove non-digits
        currentNominee: {
          ...this.state.currentNominee,
          nominee_national_id: value.replace(/\D/g, ""),
        },
      });
      return false;
    }

    // Check for valid lengths
    if (value.length === 10 || value.length === 13 || value.length === 17) {
      errors.nominee_national_id = "";
      this.setState({
        errors: { ...this.state.errors, ...errors },
        nominee_nid_value: value,
        currentNominee: {
          ...this.state.currentNominee,
          nominee_national_id: value,
        },
      });
      return true;
    } else {
      errors.nominee_national_id = "NID must be 10, 13 or 17 digits";
      this.setState({
        errors: { ...this.state.errors, ...errors },
        nominee_nid_value: value,
        currentNominee: {
          ...this.state.currentNominee,
          nominee_national_id: value,
        },
      });
      return false;
    }
  };
  handleAppointeePorichoy = (e) => {
    const value = e.target.value;
    const errors = {};

    // Allow only digits
    if (!/^\d*$/.test(value)) {
      errors.appointee_national_id = "NID can only contain numbers";
      this.setState({
        errors: { ...this.state.errors, ...errors },
        appointee_nid_value: value.replace(/\D/g, ""),
        currentAppointee: {
          ...this.state.currentAppointee,
          appointee_national_id: value.replace(/\D/g, ""),
        },
      });
      return false;
    }

    // Check for valid lengths
    if (value.length === 10 || value.length === 13 || value.length === 17) {
      errors.appointee_national_id = "";
      this.setState({
        errors: { ...this.state.errors, ...errors },
        appointee_nid_value: value,
        currentAppointee: {
          ...this.state.currentAppointee,
          appointee_national_id: value,
        },
      });
      return true;
    } else {
      errors.appointee_national_id = "NID must be 10, 13 or 17 digits";
      this.setState({
        errors: { ...this.state.errors, ...errors },
        appointee_nid_value: value,
        currentAppointee: {
          ...this.state.currentAppointee,
          appointee_national_id: value,
        },
      });
      return false;
    }
  };

  handlePolicySave = (policyData) => {
    this.setState({ formSubmitting: true });
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.error("No token found, please log in first.");
      return;
    }

    const configToken = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    // axiosNewInstance
    //   .post("api-app/purchase-policy", { ...policyData }, configToken)
    //   .then(({ data }) => {
    //     if (data.status == 0) {
    //       if (data.message?.["customer_details.mobile_no"]) {
    //         toast.error("Customer Phone number already exist");
    //       } else if (data.message?.["customer_details.email_address"]) {
    //         toast.error("Customer Email address already exist");
    //       } else {
    //         toast.error(data?.error || "Failed to save policy data");
    //       }
    //     } else {
    //       toast.success("Successfully saved policy purchase data!");
    //       this.setState({ isEditing: false });
    //       this.props.history.push("/dashboard_admin");
    //     }
    //   });
    //   axiosNewInstance
    // .post("api-app/purchase-policy", { ...policyData }, configToken)
    // .then(({ data }) => {
    //   if (data.status == 0) {
    //     const errorMessages = data.message;

    //     if (errorMessages) {
    //       Object.keys(errorMessages).forEach((key) => {
    //         const messages = errorMessages[key];
    //         if (Array.isArray(messages)) {
    //           messages.forEach((msg) => toast.error(msg));
    //         } else {
    //           toast.error(messages);
    //         }
    //       });
    //     } else {
    //       toast.error(data?.error || "Failed to save policy data");
    //     }
    //   } else {
    //     toast.success("Successfully saved policy purchase data!");
    //     this.setState({ isEditing: false });
    //     this.props.history.push("/dashboard_admin");
    //   }
    // });
    const user = this.props?.user;
    const isSubmit = Number(policyData?.policy_details?.status) === 1;
    const isCustomerUser = Number(user?.loginuser?.role_id) === 5;
    const isAgentUser = [4, 8, 9].includes(Number(user?.loginuser?.role_id));
    const verifiedAgentCode =
      isCustomerUser
        ? ""
        : (
          policyData?.policy_details?.agent_code ||
          this.state.agent_code ||
          ""
        ).trim();
    const verifiedAgentMobile = isCustomerUser
      ? ""
      : (this.state.verified_agent_mobile || "").trim();

    axiosNewInstance
      .post(
        "api-app/purchase-policy",
        {
          ...policyData,
          defer_sap_push: isSubmit,
          agent_mobile: verifiedAgentMobile,
          policy_details: {
            ...policyData.policy_details,
            agent_code: verifiedAgentCode,
            agent_mobile: verifiedAgentMobile,
          },
        },
        configToken
      )
      .then(({ data }) => {
        if (data.status == 0) {
          this.setState({ formSubmitting: false });
          const emailErrors = data.message?.["customer_details.email_address"];
          const phoneErrors = data.message?.["customer_details.mobile_no"];

          if (phoneErrors && Array.isArray(phoneErrors)) {
            toast.error(phoneErrors[0]);
          }

          if (emailErrors && Array.isArray(emailErrors)) {
            toast.error(emailErrors[0]);
          }

          if (!emailErrors && !phoneErrors) {
            toast.error(data?.error || "Failed to save policy data");
          }
        } else {
          const finishSuccess = () => {
            this.setState({ formSubmitting: false });
            toast.success("Successfully saved policy purchase data!");
            this.setState({ isEditing: false });
            this.props.history.push("/dashboard_admin");
          };

          if (!isSubmit) {
            finishSuccess();
            return;
          }

          const policyId =
            data?.customer_policy_id ??
            policyData?.policy_details?.customer_policy_id ??
            null;

          const allotBody = {
            ...policyData,
            agent_code: verifiedAgentCode,
            agent_mobile: verifiedAgentMobile,
            policy_details: {
              ...policyData.policy_details,
              agent_code: verifiedAgentCode,
              agent_mobile: verifiedAgentMobile,
              ...(policyId ? { customer_policy_id: policyId } : {}),
            },
            ...(policyId ? { customer_policy_id: policyId } : {}),
          };

          if (this.state.files[0]?.file) {
            allotBody.documents = this.state.files[0].file;
          }

          /* SAP: allot first, then API 7 document upload (TestingApiController). */
          axiosNewInstance
            .post("/api/elife/proposal/allot", allotBody, configToken)
            .then(({ data: allotData }) => {
              if (allotData?.document_upload_warning) {
                toast(allotData.document_upload_warning, { duration: 8000 });
              }
              finishSuccess();
            })
            .catch((err) => {
              this.setState({ formSubmitting: false });
              const data = err?.response?.data;
              const msg =
                (typeof data === "string" ? data : null) ||
                data?.message ||
                data?.Message ||
                data?.error ||
                (data?.sap?.message ? data.sap.message : null) ||
                (data?.step
                  ? `SAP ${data.step} failed (${data.ref_unique_id || ""})`
                  : null) ||
                err?.message ||
                "eLife proposal allot failed";
              console.error("eLife proposal allot:", data || err);
              toast.error(
                "Policy saved locally, but eLife proposal allot failed: " + msg
              );
              this.setState({ isEditing: false });
              this.props.history.push("/dashboard_admin");
            });
        }
      })
      .catch((err) => {
        this.setState({ formSubmitting: false });
        console.error("Error submitting policy:", err);
        toast.error("An error occurred while saving the policy.");
      });
  };

  handleBack = () => {
    this.props?.history.push("/premium-calculator", { fromPolicyBuy: true });
  };

  // Add this new method to the class
  convertFileToBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // const base64String = reader.result;
        // // Remove the data URL prefix (e.g., "data:image/jpeg;base64,")
        // const base64Content = base64String.split(",")[1];
        // resolve(base64Content);
        resolve(reader.result); // included the data URI prefix
      };
      reader.onerror = (error) => reject(error);
    });
  };

  renderFilePreview = (file) => {
    const isPDF = file.fileType === "application/pdf";
    const isImage = file.fileType.startsWith("image/");

    return (
      <div
        key={file.id}
        style={{
          position: "relative",
          width: "200px",
          height: "200px",
          border: "1px solid #ccc",
          borderRadius: "5px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f8f9fa",
        }}
      >
        {isImage ? (
          <img
            src={file.preview}
            alt="Preview"
            style={{
              width: "100%",
              height: "150px",
              objectFit: "cover",
            }}
          />
        ) : isPDF ? (
          <div
            style={{
              height: "150px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#e9ecef",
            }}
          >
            <i
              className="fas fa-file-pdf"
              style={{ fontSize: "48px", color: "#dc3545" }}
            ></i>
          </div>
        ) : (
          <div
            style={{
              height: "150px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#e9ecef",
            }}
          >
            <i
              className="fas fa-file"
              style={{ fontSize: "48px", color: "#6c757d" }}
            ></i>
          </div>
        )}

        <div
          style={{
            padding: "8px",
            borderTop: "1px solid #dee2e6",
            backgroundColor: "white",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#495057",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {file.fileName}
          </div>
          <div
            style={{
              fontSize: "10px",
              color: "#6c757d",
            }}
          >
            {file.fileSize}
          </div>
        </div>

        {/* Delete Button */}
        <button
          onClick={() => this.handleDelete(file.id)}
          style={{
            position: "absolute",
            top: "5px",
            right: "5px",
            background: "rgba(220, 53, 69, 0.9)",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            transition: "background 0.2s",
          }}
          onMouseOver={(e) =>
            (e.target.style.background = "rgba(220, 53, 69, 1)")
          }
          onMouseOut={(e) =>
            (e.target.style.background = "rgba(220, 53, 69, 0.9)")
          }
        >
          ✕
        </button>
      </div>
    );
  };

  render() {
    const customStyles = {
      control: (base) => ({
        ...base,
        minHeight: "38px",
        border: "1px solid #ced4da",
        borderRadius: "4px",
        boxShadow: "none",
        "&:hover": {
          border: "1px solid #ced4da",
        },
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
          ? "#004e8f"
          : state.isFocused
            ? "#e6f3ff"
            : "white",
        color: state.isSelected ? "white" : "#333",
        "&:hover": {
          backgroundColor: state.isSelected ? "#004e8f" : "#e6f3ff",
        },
      }),
    };

    const {
      validator,
      formdata,
      customer,
      allowNomineeCustom,
      currentNominee,
      errors,
      // nominees,
      // payment_by,
      allowCustom,
      // allowMenual,
      // nid_value,
      currentAppointee,
      // appointees,
      showAppointeeForm,
      // isModalOpen,
      isEditing,
      // draft_policy_details,
    } = this.state;
    const calCulatorData = this.props?.returnCalculator?.calculation;
    const user = this.props?.user;

    const { search } = this.props.location;
    let is_nominee = false;

    var getdata = search.split("&");

    if (getdata.includes("nominee=true")) {
      is_nominee = true;
    }

    var tab_active = this.state.tab_active;
    const lang = this.props.lang;
    const isCustomerUser = Number(user?.loginuser?.role_id) === 5;
    const isAgentUser = [4, 8, 9].includes(Number(user?.loginuser?.role_id));
    const canProceedWithPolicyForm =
      this.props.location?.state?.ocrDocumentBase64 ||
      isCustomerUser ||
      (isAgentUser
        ? Boolean(this.state.agent_code) && !this.state.agent_lookup_loading
        : Boolean(this.state.agent_code));
    const showPolicySubmitActions = canProceedWithPolicyForm;
    return (
      <Fragment>
        {this.state.formSubmitting && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.35)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 10,
                padding: "18px 20px",
                minWidth: 280,
                boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                display: "flex",
                alignItems: "center",
                gap: 12,
              }}
            >
              <div className="spinner-border text-primary" role="status" aria-label="Loading" />
              <div style={{ lineHeight: 1.2 }}>
                <div style={{ fontWeight: 600 }}>Submitting Policy…</div>
                <div style={{ color: "#6c757d", fontSize: 13, marginTop: 4 }}>
                  Please wait.
                </div>
              </div>
            </div>
          </div>
        )}
        <form action="#" id="policyform" className="policy_form">
          <Tabs
            activeTab={is_nominee ? 2 : tab_active}
            ulClassName="pro-tab-items"
            activityClassName="bg-success"
          >
            <Tab
              title={
                lang === "bn" ? "আবেদনকারী'র তথ্য" : "Applicant's Information"
              }
              className="service-tab-nav"
            >
              <div className="mt-3">
                {this.state.message != "" &&
                  this.state.message_type == "success" &&
                  tab_active == 1 && (
                    <div className="col-sm-12" style={{ marginTop: "10px" }}>
                      <div
                        className="alert  alert-success alert-dismissible fade show"
                        role="alert"
                      >
                        {this.state.message}
                        <button
                          type="button"
                          className="close"
                          data-dismiss="alert"
                          aria-label="Close"
                          onClick={() => this.handleMessageClose()}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                  )}
                {this.state.message != "" &&
                  this.state.message_type == "danger" &&
                  tab_active == 1 && (
                    <div className="col-sm-12" style={{ marginTop: "10px" }}>
                      <div
                        className="alert  alert-danger alert-dismissible fade show"
                        role="alert"
                      >
                        {this.state.message}
                        <button
                          type="button"
                          className="close"
                          data-dismiss="alert"
                          aria-label="Close"
                          onClick={() => this.handleMessageClose()}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                  )}
                {/* -------------------------------------------------------- Calculator info start -------- */}
                <div className="row">
                  <div className="col-12 mb-2 d-flex justify-content-between align-items-center">
                    <h5
                      style={{
                        margin: 0,
                        color: "#004e8f",
                        fontWeight: "600",
                        fontSize: "16px",
                      }}
                    >
                      {lang === "bn"
                        ? "পলিসি ও প্রিমিয়াম বিবরণ"
                        : "Policy & Premium Details"}
                    </h5>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      style={{
                        borderColor: "#004e8f",
                        color: "#004e8f",
                        fontWeight: "600",
                        padding: "4px 14px",
                        borderRadius: "4px",
                      }}
                      onClick={() => this.setState({ showCalculatorModal: true })}
                    >
                      <i className="fa fa-edit mr-1"></i>{" "}
                      {lang === "bn" ? "প্ল্যান পরিবর্তন / হিসাব করুন" : "Edit Plan / Calculate"}
                    </button>
                  </div>
                  {calCulatorData?.message !== "Success" && (
                    <div className="col-12">
                      <div className="alert alert-warning d-flex justify-content-between align-items-center mb-3">
                        <span>
                          {lang === "bn"
                            ? "পলিসি বা প্রিমিয়াম তথ্য এখনও নিশ্চিত হয়নি। অনুগ্রহ করে ক্যালকুলেটর থেকে প্ল্যান ও প্রিমিয়াম নির্ধারণ করুন।"
                            : "Policy or premium information is missing or incomplete. Please calculate and select your plan."}
                        </span>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          style={{ backgroundColor: "#004e8f", borderColor: "#004e8f" }}
                          onClick={() => this.setState({ showCalculatorModal: true })}
                        >
                          {lang === "bn" ? "প্ল্যান নির্ধারণ করুন" : "Calculate Plan"}
                        </button>
                      </div>
                    </div>
                  )}
                  {calCulatorData?.message === "Success" && (
                    <div className="calculated-result row">
                      <div className="col-md-4">
                        {" "}
                        <p>
                          <span className="label" style={{ color: "#004e8f" }}>
                            <LangData keyname="label_premium_calculator_plan_name" />
                            :{" "}
                          </span>{" "}
                          {calCulatorData.policy}
                        </p>
                      </div>
                      <div className="col-md-4">
                        {" "}
                        <p>
                          <span className="label" style={{ color: "#004e8f" }}>
                            {" "}
                            <LangData keyname="label_premium_calculator_customer_age" />
                            :
                          </span>{" "}
                          {calCulatorData.age}
                        </p>
                      </div>
                      <div className="col-md-4">
                        {" "}
                        <p>
                          <span className="label" style={{ color: "#004e8f" }}>
                            <LangData keyname="label_premium_calculator_monthly_premium" />
                            :{" "}
                          </span>
                          {calCulatorData.premium_amount}
                        </p>
                      </div>
                      <div className="col-md-4">
                        {" "}
                        <p>
                          <span className="label" style={{ color: "#004e8f" }}>
                            <LangData keyname="label_premium_calculator_term" />
                            :
                          </span>{" "}
                          {calCulatorData.term}
                        </p>
                      </div>
                      <div className="col-md-4">
                        {" "}
                        {/* <p>
                    <span className="label">
                      <LangData keyname="label_premium_calculator_mode" />
                      :
                    </span>{" "}
                    {calCulatorData.mode}
                  </p> */}
                        <p>
                          <span className="label" style={{ color: "#004e8f" }}>
                            <LangData keyname="label_premium_calculator_mode" />
                            :
                          </span>{" "}
                          {calCulatorData.mode === "M" ||
                            calCulatorData.mode === "Monthly"
                            ? "Monthly"
                            : calCulatorData.mode === "Q" ||
                              calCulatorData.mode === "Quarterly"
                              ? "Quarterly"
                              : calCulatorData.mode === "H" ||
                                calCulatorData.mode === "Half Yearly"
                                ? "Half Yearly"
                                : calCulatorData.mode === "Y" ||
                                  calCulatorData.mode === "Yearly"
                                  ? "Yearly"
                                  : calCulatorData.mode === "N" ||
                                    calCulatorData.mode === "Single"
                                    ? "Single"
                                    : calCulatorData.mode === "S" ||
                                      calCulatorData.mode === "Single"
                                      ? "Single"
                                      : "Unknown"}
                        </p>
                      </div>
                      <div className="col-md-4">
                        {" "}
                        <p>
                          <span className="label" style={{ color: "#004e8f" }}>
                            <LangData keyname="label_premium_calculator_sum_assured" />
                            :
                          </span>{" "}
                          {calCulatorData.sum_assured}
                        </p>
                      </div>
                      <div className="col-md-4">
                        {" "}
                        {calCulatorData?.payload?.gender && (
                          <p>
                            <span
                              className="label"
                              style={{ color: "#004e8f" }}
                            >
                              <LangData keyname="label_policy_holder_gender" />:
                            </span>{" "}
                            {calCulatorData?.payload?.gender === "M"
                              ? "Male"
                              : "Female"}
                          </p>
                        )}
                      </div>
                      {/* {(calCulatorData?.payload?.plan === "802" ||
                  calCulatorData?.payload?.plan === "804" ||
                  calCulatorData?.payload?.plan === "805" ||
                  calCulatorData?.payload?.plan === "806" ||
                  calCulatorData?.payload?.plan === "807" ||
                  calCulatorData?.payload?.plan === "808" ||
                  calCulatorData?.payload?.plan === "813" ||
                  calCulatorData?.payload?.plan === "814") && (
                  <div className="col-md-4">
                    {" "}
                    <p>
                      <span className="label">
                        <LangData keyname="label_premium_calculator_accidental_coverage" />
                        :
                      </span>{" "}
                      {calCulatorData?.payload?.accidental_cover === "0"
                        ? "No"
                        : "Yes"}
                    </p>
                  </div>
                )}

                {(calCulatorData?.payload?.plan === "802" ||
                  calCulatorData?.payload?.plan === "804" ||
                  calCulatorData?.payload?.plan === "805" ||
                  calCulatorData?.payload?.plan === "806" ||
                  calCulatorData?.payload?.plan === "807" ||
                  calCulatorData?.payload?.plan === "808" ||
                  calCulatorData?.payload?.plan === "813" ||
                  calCulatorData?.payload?.plan === "814") && (
                  <div className="col-md-4">
                    <p>
                      <span className="label">
                        <LangData keyname="label_premium_calculator_hostpital_rider_benifit" />
                        :
                      </span>{" "}
                         {calCulatorData?.payload?.scbSa === "0"
                        ? "No"
                        : calCulatorData?.payload?.scbSa}
                    </p>
                  </div>
                )}
                {(calCulatorData?.payload?.plan === "802" ||
                  calCulatorData?.payload?.plan === "804" ||
                  calCulatorData?.payload?.plan === "806" ||
                  calCulatorData?.payload?.plan === "807" ||
                  calCulatorData?.payload?.plan === "808" ||
                  calCulatorData?.payload?.plan === "813" ||
                  calCulatorData?.payload?.plan === "815") && (
                  <div className="col-md-4">
                    <p>
                      <span className="label">
                        <LangData keyname="label_premium_calculator_critical_illness" />
                        :
                      </span>{" "}
                      {calCulatorData?.payload?.critical_illness === "0"
                        ? "No"
                        : calCulatorData?.payload?.critical_illness ===
                          "1"
                        ? "Yes"
                        : calCulatorData?.payload?.critical_illness ===
                          "2"
                        ? "Other"
                        : "N/A"}
                    </p>
                  </div>
                )} */}
                      {(() => {
                        const planIdFromName = Object.keys(policyNameId).find(
                          (id) =>
                            policyNameId[id]?.trim().toLowerCase() ===
                            calCulatorData?.policy?.trim().toLowerCase()
                        );
                        const plan = String(
                          calCulatorData?.payload?.plan ||
                            calCulatorData?.payload?.policy ||
                            calCulatorData?.policyId ||
                            planIdFromName ||
                            ""
                        );
                        const isSingleMode =
                          calCulatorData?.mode === "N" ||
                          calCulatorData?.mode === "Single" ||
                          calCulatorData?.payload?.mode === "N" ||
                          calCulatorData?.payload?.polMode === "N";
                        const supportsTermRider =
                          !["803", "809", "816"].includes(plan) && !isSingleMode;
                        const trSa =
                          calCulatorData?.payload?.trSa ??
                          calCulatorData?.payload?.term_rider ??
                          calCulatorData?.term_rider_sa;
                        const planSet1 = [
                          "802",
                          "804",
                          "805",
                          "806",
                          // "807",
                          "808",
                          "813",
                          "814",
                          "815",
                        ];
                        const planSet2 = [
                          "802",
                          "804",
                          "805",
                          "806",
                          "807",
                          "808",
                          "813",
                          "814",
                          "815",
                        ];
                        const planSet3 = [
                          "802",
                          "804",
                          "806",
                          "807",
                          "808",
                          "813",
                          "815",
                        ];

                        return (
                          <>
                            {supportsTermRider && (
                              <div className="col-md-4">
                                <p>
                                  <span
                                    className="label"
                                    style={{ color: "#004e8f" }}
                                  >
                                    {lang === "bn"
                                      ? "টার্ম রাইডার সাম অ্যাসুরড"
                                      : "Term Rider Sum Assured"}
                                    :
                                  </span>{" "}
                                  {trSa && trSa !== "0" && trSa !== 0
                                    ? trSa
                                    : "No"}
                                </p>
                              </div>
                            )}

                            {planSet1.includes(plan) && (
                              <div className="col-md-4">
                                <p>
                                  <span
                                    className="label"
                                    style={{ color: "#004e8f" }}
                                  >
                                    <LangData keyname="label_premium_calculator_accidental_coverage" />
                                    :
                                  </span>{" "}
                                  {calCulatorData?.payload?.accidental_cover ===
                                    "0"
                                    ? "No"
                                    : "Yes"}
                                </p>
                              </div>
                            )}

                            {planSet2.includes(plan) && (
                              <div className="col-md-4">
                                <p>
                                  <span
                                    className="label"
                                    style={{ color: "#004e8f" }}
                                  >
                                    <LangData keyname="label_premium_calculator_hostpital_rider_benifit" />
                                    :
                                  </span>{" "}
                                  {calCulatorData?.payload?.hcbSa === "0" ||
                                    !calCulatorData?.payload?.hcbSa
                                    ? "No"
                                    : calCulatorData?.payload?.hcbSa}
                                </p>
                              </div>
                            )}

                            {planSet3.includes(plan) && (
                              <div className="col-md-4">
                                <p>
                                  <span
                                    className="label"
                                    style={{ color: "#004e8f" }}
                                  >
                                    <LangData keyname="label_premium_calculator_critical_illness" />
                                    :
                                  </span>{" "}
                                  {calCulatorData?.payload?.critical_illness ===
                                    "0"
                                    ? "0"
                                    : calCulatorData?.payload
                                      ?.critical_illness === "1"
                                      ? parseInt(calCulatorData?.sum_assured) / 2
                                      : calCulatorData?.payload
                                        ?.critical_illness === "2"
                                        ? calCulatorData?.critical_sum
                                        : "N/A"}
                                </p>
                              </div>
                            )}
                          </>
                        );
                      })()}
                    </div>
                  )}
                </div>
                {!isEditing && (
                  <input
                    type="button"
                    value={lang === "bn" ? "পূর্বে" : "Back"}
                    className="btn btn-secondary"
                    onClick={() => this.handleBack()}
                  />
                )}

                {/* -------------------------------------------------------- Calculator info end -------- */}

                <div className="mt-3"></div>
                {isAgentUser && this.state.agent_lookup_loading && (
                  <p className="text-muted mb-3">Loading your agent code from SAP…</p>
                )}
                {isAgentUser && this.state.agent_lookup_error && (
                  <p className="text-danger mb-3">{this.state.agent_lookup_error}</p>
                )}
                {isAgentUser && this.state.agent_code && (
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label>Agent Code</label>
                      <input
                        type="text"
                        className="form-control"
                        readOnly
                        value={this.state.agent_code}
                      />
                    </div>
                    {this.state.agent_name && (
                      <div className="col-md-4">
                        <label>Agent Name</label>
                        <input
                          type="text"
                          className="form-control"
                          readOnly
                          value={this.state.agent_name}
                        />
                      </div>
                    )}
                  </div>
                )}
                {!isCustomerUser && !isAgentUser && (
                  <>
                    <h3
                      className="info__title"
                      style={{
                        color: "#004e8f",
                        fontSize: "24px",
                        marginBottom: "24px",
                        fontWeight: "600",
                      }}
                    >
                      <LangData keyname="heading_agent_verification" />
                    </h3>
                    <div className="row">
                      <div className="col-md-4">
                        <label for="">
                          <LangData keyname="label_agent_mobile_number" />
                          <span>*</span>
                        </label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            placeholder="Agent Mobile Number"
                            id=""
                            value={this.state.nid_value || ""}
                            className="form-control input-control-area rounded-left"
                            style={{ borderRight: "none" }}
                            onChange={(e) => this.handlePorichoy(e)}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            pattern="[0-9]*"
                            inputMode="numeric"
                            maxLength={11}
                          />
                          <button
                            className="btn btn-primary"
                            type="button"
                            id="basic-addon2"
                            onClick={this.handleAgentLookup}
                            disabled={
                              !this.state.nid_value ||
                              this.state.nid_value.length !== 11 ||
                              validator.policy_holder_nid ||
                              this.state.agent_lookup_loading
                            }
                            style={{ height: "30px" }}
                          >
                            {this.state.agent_lookup_loading ? (
                              "Checking..."
                            ) : (
                              <LangData keyname="label_check" />
                            )}
                          </button>
                        </div>
                        {validator.policy_holder_nid && (
                          <span className="help-block form-text text-danger">
                            {validator.policy_holder_nid}
                          </span>
                        )}
                        {this.state.agent_lookup_error && (
                          <span className="help-block form-text text-danger">
                            {this.state.agent_lookup_error}
                          </span>
                        )}
                      </div>

                      {/* Auto-populated Agent Code (from agentEnquiryLogin response) */}
                      {(this.state.agent_code || this.state.agent_lookup_loading) && (
                        <>
                          <div className="col-md-4">
                            <label for="agent_code_input">
                              Agent Code<span>*</span>
                            </label>
                            <input
                              id="agent_code_input"
                              type="text"
                              readOnly
                              placeholder="Agent Code"
                              value={
                                this.state.agent_lookup_loading
                                  ? "Loading..."
                                  : this.state.agent_code || ""
                              }
                              className="form-control"
                            />
                          </div>
                          {(this.state.agent_name || this.state.agent_lookup_loading) && (
                            <div className="col-md-4">
                              <label for="agent_name_input">
                                Agent Name
                              </label>
                              <input
                                id="agent_name_input"
                                type="text"
                                readOnly
                                placeholder="Agent Name"
                                value={
                                  this.state.agent_lookup_loading
                                    ? "Loading..."
                                    : this.state.agent_name || ""
                                }
                                className="form-control"
                              />
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}

                {/* Staff: after agent verify. Customer (role 5): form opens immediately. */}
                {canProceedWithPolicyForm && (
                  <>
                    {/* "Do you have a National ID?" toggle (mirrors nominee flow) */}
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="hasHolderNid"
                            checked={this.state.hasHolderNid}
                            onChange={(e) =>
                              this.setState({
                                hasHolderNid: e.target.checked,
                                /* Toggle only shows/hides the NID + Check row. The Personal
                                   Information block stays visible (manual entry path) until
                                   a successful NID Check swaps it to the read-only block. */
                                holder_nid_value: "",
                                holder_nid_error: "",
                                allowCustom: true,
                                customer: {},
                              })
                            }
                          />
                          <label className="form-check-label" htmlFor="hasHolderNid">
                            <LangData keyname="label_has_holder_national_id" />
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Policy-holder NID + Check (same API as nominee: search-by-nid) */}
                    {this.state.hasHolderNid && (
                      <div className="row">
                        <div className="col-md-4">
                          <label htmlFor="holder_nid_input">
                            <LangData keyname="label_policy_holder_nid" />
                            <span>*</span>
                          </label>
                          <div className="input-group mb-3">
                            <input
                              id="holder_nid_input"
                              type="text"
                              placeholder="NID Number"
                              value={this.state.holder_nid_value || ""}
                              className="form-control input-control-area rounded-left"
                              style={{ borderRight: "none" }}
                              onChange={(e) =>
                                this.setState({
                                  holder_nid_value: (e.target.value || "").replace(
                                    /\D/g,
                                    ""
                                  ),
                                  holder_nid_error: "",
                                })
                              }
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) e.preventDefault();
                              }}
                              pattern="[0-9]*"
                              inputMode="numeric"
                              autoComplete="off"
                            />
                            <button
                              className="btn btn-primary"
                              type="button"
                              onClick={this.handleHolderNidLookup}
                              disabled={
                                !this.state.holder_nid_value ||
                                this.state.holder_nid_loading
                              }
                              style={{ height: "30px" }}
                            >
                              {this.state.holder_nid_loading ? (
                                "Checking..."
                              ) : (
                                <LangData keyname="label_check" />
                              )}
                            </button>
                          </div>
                          {this.state.holder_nid_error && (
                            <span className="help-block form-text text-danger">
                              {this.state.holder_nid_error}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {/* --------------------------------- applicants info start by nid verification--------- */}
                    {canProceedWithPolicyForm && (
                      <h3
                        className="info__title"
                        style={{
                          color: "#004e8f",
                          fontSize: "24px",
                          marginTop: "8px",
                          marginBottom: "24px",
                          fontWeight: "600",
                        }}
                      >
                        <LangData keyname="label_personal_information" />
                      </h3>
                    )}

                    {Object.keys(customer)?.length > 0 && (
                      <div className="row ">
                        {/* National id */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_nid" />
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="NID"
                            ref={(input) =>
                              (this.policy_holder_national_id = input)
                            }
                            value={customer.national_id || ""}
                            onChange={(e) =>
                              this.setState({
                                customer: {
                                  ...this.state.customer,
                                  national_id: (e.target.value || "").replace(/\D/g, ""),
                                },
                              })
                            }
                            className="form-control"
                          />
                          {validator.policy_holder_national_id && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_national_id}
                            </span>
                          )}
                        </div>

                        {/* Email */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_email" />
                          </label>
                          <input
                            type="email"
                            placeholder="E-mail"
                            ref={(input) => (this.policy_holder_email = input)}
                            value={customer.email || ""}
                            onChange={(e) => this.setState({ customer: { ...this.state.customer, email: e.target.value } })}
                            className="form-control"
                          />
                          {validator.policy_holder_email && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_email}
                            </span>
                          )}
                        </div>

                        {/* dob */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_dob" />
                            <span>*</span>
                          </label>
                          <DatePicker
                            selected={this.parseYmdToLocalDate(customer.date_of_birth)}
                            onChange={() => { }}
                            className="form-control"
                            dateFormat="yyyy/MM/dd"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            autoComplete="off"
                            readOnly
                            disabled
                            placeholderText="Select Date of Birth"
                            ref={(instance) => {
                              if (instance) {
                                this.policy_holder_dob = {
                                  value: customer.date_of_birth
                                    ? this.parseDateToYmd(customer.date_of_birth)
                                    : ""
                                };
                              }
                            }}
                          />
                          {validator.policy_holder_dob && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_dob}
                            </span>
                          )}
                        </div>

                        {/* First Name */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_first_name" />
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="First Name"
                            ref={(input) => (this.policy_holder_first_name = input)}
                            value={customer.first_name || ""}
                            onChange={(e) => this.setState({ customer: { ...this.state.customer, first_name: e.target.value } })}
                            className="form-control"
                          />
                          {validator.policy_holder_first_name && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_first_name}
                            </span>
                          )}
                        </div>

                        {/* Last Name */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_last_name" />
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Last Name"
                            ref={(input) => (this.policy_holder_last_name = input)}
                            value={customer.last_name || ""}
                            onChange={(e) => this.setState({ customer: { ...this.state.customer, last_name: e.target.value } })}
                            className="form-control"
                          />
                          {validator.policy_holder_last_name && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_last_name}
                            </span>
                          )}
                        </div>

                        {/* Gender */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_gender" />
                            <span>*</span>
                          </label>
                          <select
                            onChange={(e) => this.setState({ customer: { ...this.state.customer, gender: e.target.value } })}
                            ref={(input) => (this.policy_holder_gender = input)}
                            value={
                              customer.gender === "Male" || customer.gender === "M"
                                ? "M"
                                : customer.gender === "Female" ||
                                  customer.gender === "F"
                                  ? "F"
                                  : ""
                            }
                            className={
                              validator.policy_holder_gender
                                ? "form-control from-style input-error"
                                : "form-control from-style"
                            }
                          >
                            <option value="">Select Gender</option>
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                          </select>
                          {validator.policy_holder_gender && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_gender}
                            </span>
                          )}
                        </div>

                        {/* Father Name */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_father_name" />
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Father Name"
                            ref={(input) =>
                              (this.policy_holder_father_name = input)
                            }
                            value={customer.father_name || ""}
                            onChange={(e) => this.setState({ customer: { ...this.state.customer, father_name: e.target.value } })}
                            className="form-control"
                          />
                          {validator.policy_holder_father_name && (
                            <span className="help-block form-text text-danger">
                              The father name field is required.
                            </span>
                          )}
                        </div>

                        {/* Mother Name */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_mother_name" />
                          </label>
                          <input
                            type="text"
                            placeholder="Mother Name"
                            ref={(input) =>
                              (this.policy_holder_mother_name = input)
                            }
                            value={customer.mother_name || ""}
                            onChange={(e) => this.setState({ customer: { ...this.state.customer, mother_name: e.target.value } })}
                            className="form-control"
                          />
                          {validator.policy_holder_mother_name && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_mother_name}
                            </span>
                          )}
                        </div>

                        {/* Spouse Name */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_spouse" />
                          </label>
                          <input
                            type="text"
                            placeholder="Spouse"
                            ref={(input) => (this.policy_holder_spouse = input)}
                            value={customer.spouse_name || ""}
                            onChange={(e) => this.setState({ customer: { ...this.state.customer, spouse_name: e.target.value } })}
                            className="form-control"
                          />
                          {validator.policy_holder_spouse && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_spouse}
                            </span>
                          )}
                        </div>

                        {/* Mobile Number */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_mobile_number" />
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Mobile Number"
                            ref={(input) =>
                              (this.policy_holder_mobile_number = input)
                            }
                            value={customer.mobile || ""}
                            onChange={(e) => this.setState({ customer: { ...this.state.customer, mobile: e.target.value } })}
                            className="form-control"
                          />
                          {validator.policy_holder_mobile_number && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_mobile_number}
                            </span>
                          )}
                        </div>

                        {/* Occupation */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_occupation" />
                            <span>*</span>
                          </label>
                          <select
                            ref={(input) => (this.policy_holder_occupation = input)}
                            value={customer.occupation || "10"}
                            onChange={(e) =>
                              this.setState({ customer: { ...this.state.customer, occupation: e.target.value } })
                            }
                            className="form-control"
                          >
                            <option value="10">Service</option>
                            <option value="60">Business</option>
                            <option value="63">Agriculture</option>
                            <option value="70">Others</option>
                          </select>
                          {validator.policy_holder_occupation && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_occupation}
                            </span>
                          )}
                        </div>

                        {/* annual income */}
                        <div className="col-md-3" style={{ marginBottom: "20px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_annual_income" />
                            <span>*</span>
                          </label>
                          <select
                            ref={(input) =>
                              (this.policy_holder_annual_income = input)
                            }
                            className="form-control"
                            value={customer.annual_income || "1"}
                            onChange={(e) =>
                              this.setState({
                                customer: {
                                  ...this.state.customer,
                                  annual_income: e.target.value,
                                },
                              })
                            }
                          >
                            <option value="1">Up to 500000</option>
                            <option value="2">500001-1000000</option>
                            <option value="3">1000001 above</option>
                          </select>
                          {validator.policy_holder_annual_income && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_annual_income}
                            </span>
                          )}
                        </div>

                        {/* education*/}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_education" />
                          </label>
                          <select
                            ref={(input) => (this.policy_holder_education = input)}
                            className="form-control"
                            value={customer.education || "S"}
                            onChange={(e) =>
                              this.setState({ customer: { ...this.state.customer, education: e.target.value } })
                            }
                          >
                            <option value="S">SSC</option>
                            <option value="I">HSC</option>
                            <option value="G">GRADUATE</option>
                            <option value="P">POST GRADUATE</option>
                            <option value="O">Other</option>
                          </select>
                          {validator.policy_holder_education && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_education}
                            </span>
                          )}
                        </div>

                        {/* birth place */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_place_of_birth" />
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Place of birth"
                            ref={(input) =>
                              (this.policy_holder_place_of_birth = input)
                            }
                            value={customer.place_of_birth || ""}
                            onChange={(e) =>
                              this.setState({
                                customer: {
                                  ...this.state.customer,
                                  place_of_birth: e.target.value,
                                },
                              })
                            }
                            className="form-control"
                          />
                          {validator.policy_holder_place_of_birth && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_place_of_birth}
                            </span>
                          )}
                        </div>

                        {/* Nationality  */}
                        <div className="col-md-3" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_nationality" />
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Nationality"
                            ref={(input) =>
                              (this.policy_holder_nationality = input)
                            }
                            value={customer.nationality || "Bangladeshi"}
                            onChange={(e) => this.setState({ customer: { ...this.state.customer, nationality: e.target.value } })}
                            className="form-control"
                          />
                          {validator.policy_holder_nationality && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_nationality}
                            </span>
                          )}
                        </div>

                        {/* Present Address */}
                        <div className="col-md-6" style={{ marginBottom: "35px" }}>
                          <label>
                            <LangData keyname="label_policy_holder_present_address" />
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Present Address"
                            ref={(input) =>
                              (this.policy_holder_present_address = input)
                            }
                            value={customer.present_address || ""}
                            onChange={(e) => this.setState({ customer: { ...this.state.customer, present_address: e.target.value } })}
                            className="form-control"
                          />
                          {validator.policy_holder_present_address && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_present_address}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {allowCustom && !this.props.location?.state?.ocrDocumentBase64 && (
                      <>
                        {" "}
                        <div className="row mt-3">
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label>
                              <LangData keyname="label_policy_holder_nid" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="NID"
                              ref={(input) =>
                                (this.policy_holder_national_id = input)
                              }
                              value={this.state.holder_nid_value || ""}
                              onChange={(e) =>
                                this.setState({
                                  holder_nid_value: (e.target.value || "").replace(
                                    /\D/g,
                                    ""
                                  ),
                                })
                              }
                              className="form-control"
                            />
                            {validator.policy_holder_national_id && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_national_id}
                              </span>
                            )}
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              <LangData keyname="label_policy_holder_email" />
                            </label>
                            {/* <span>*</span> */}
                            <input
                              type="email"
                              placeholder="E-mail"
                              ref={(input) => (this.policy_holder_email = input)}
                              className="form-control"
                            />

                            {validator.policy_holder_email && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_email}
                              </span>
                            )}
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_policy_holder_dob" />
                              <span>*</span>
                            </label>
                            <DatePicker
                              selected={this.parseYmdToLocalDate(calCulatorData?.dateOf_birth)}
                              onChange={() => { }}
                              className="form-control"
                              dateFormat="yyyy/MM/dd"
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              autoComplete="off"
                              readOnly
                              disabled
                              placeholderText="Select Date of Birth"
                              ref={(instance) => {
                                if (instance) {
                                  this.policy_holder_dob = {
                                    value: calCulatorData?.dateOf_birth
                                      ? this.parseDateToYmd(calCulatorData.dateOf_birth)
                                      : ""
                                  };
                                }
                              }}
                            />

                            {validator.policy_holder_dob && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_dob}
                              </span>
                            )}
                          </div>

                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_policy_holder_first_name" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="First Name"
                              ref={(input) =>
                                (this.policy_holder_first_name = input)
                              }
                              id=""
                              className="form-control"
                            />

                            {validator.policy_holder_first_name && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_first_name}
                              </span>
                            )}
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_policy_holder_last_name" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Last Name"
                              ref={(input) =>
                                (this.policy_holder_last_name = input)
                              }
                              id=""
                              className="form-control"
                            />

                            {validator.policy_holder_last_name && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_last_name}
                              </span>
                            )}
                          </div>

                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_policy_holder_gender" />
                              <span>*</span>
                            </label>
                            <select
                              ref={(input) => (this.policy_holder_gender = input)}
                              className={
                                validator.policy_holder_gender
                                  ? "form-control from-style input-error"
                                  : "form-control from-style"
                              }
                              value={
                                calCulatorData?.payload?.gender
                                  ? calCulatorData?.payload?.gender
                                  : ""
                              }
                              readOnly
                              disabled
                            >
                              <option value="">Select Gender</option>
                              <option value="M">Male</option>
                              <option value="F">Female</option>
                              {/* <option
                      value="3"
              
                    >
                      Common
                    </option> */}
                            </select>

                            {validator.policy_holder_gender && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_gender}
                              </span>
                            )}
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              <LangData keyname="label_policy_holder_father_name" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Father Name"
                              ref={(input) =>
                                (this.policy_holder_father_name = input)
                              }
                              className="form-control"
                            />

                            {validator.policy_holder_father_name && (
                              <span className="help-block form-text text-danger">
                                The father name field is required.
                              </span>
                            )}
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              <LangData keyname="label_policy_holder_mother_name" />
                              {/* <span>*</span> */}
                            </label>
                            <input
                              type="text"
                              placeholder="Mother Name"
                              ref={(input) =>
                                (this.policy_holder_mother_name = input)
                              }
                              className="form-control"
                            />

                            {validator.policy_holder_mother_name && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_mother_name}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_policy_holder_spouse" />
                            </label>
                            <input
                              type="text"
                              placeholder="Spouse"
                              ref={(input) => (this.policy_holder_spouse = input)}
                              className="form-control"
                            />

                            {validator.policy_holder_spouse && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_spouse}
                              </span>
                            )}
                          </div>

                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_mobile_number" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Mobile Number"
                              pattern="\d"
                              ref={(input) =>
                                (this.policy_holder_mobile_number = input)
                              }
                              className="form-control"
                            />

                            {validator.policy_holder_mobile_number && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_mobile_number}
                              </span>
                            )}
                          </div>

                          {/* <div
                  className="col-md-3"
                  style={{ marginBottom: "30px" }}
                >
                  <label for="">
                    {" "}
                    <LangData keyname="label_policy_holder_occupation" />
                    <span>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Occupation"
                    ref={(input) =>
                      (this.policy_holder_occupation = input)
                    }
                    className="form-control"
                  />

                  {validator.policy_holder_occupation && (
                    <span className="help-block form-text text-danger">
                      {validator.policy_holder_occupation}
                    </span>
                  )}
                </div> */}
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_policy_holder_occupation" />
                              <span>*</span>
                            </label>
                            <select
                              ref={(input) =>
                                (this.policy_holder_occupation = input)
                              }
                              className="form-control"
                            >
                              <option value="">Select Occupation</option>
                              <option value="10">Service</option>
                              <option value="60">Business</option>
                              <option value="63">Agriculture</option>
                              <option value="70">Others</option>
                            </select>

                            {validator.policy_holder_occupation && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_occupation}
                              </span>
                            )}
                          </div>
                          {/* <div
                  className="col-md-3"
                  style={{ marginBottom: "30px" }}
                >
                  <label for="">
                    {" "}
                    <LangData keyname="label_policy_holder_annual_income" />
                    <span>*</span>
                  </label>
                  <input
                    type="number"
                    placeholder="Annual income"
                    ref={(input) =>
                      (this.policy_holder_annual_income = input)
                    }
                    className="form-control"
                  />

                  {validator.policy_holder_annual_income && (
                    <span className="help-block form-text text-danger">
                      {validator.policy_holder_annual_income}
                    </span>
                  )}
                </div> */}
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "20px" }}
                          >
                            <label>
                              <LangData keyname="label_policy_holder_annual_income" />
                              <span>*</span>
                            </label>
                            <select
                              ref={(input) =>
                                (this.policy_holder_annual_income = input)
                              }
                              className="form-control"
                            >
                              <option value="">Select Annual Income</option>
                              <option value="1">Up to 500000</option>
                              <option value="2">500001-1000000</option>
                              <option value="3">1000001 above</option>
                            </select>

                            {validator.policy_holder_annual_income && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_annual_income}
                              </span>
                            )}
                          </div>
                          {/* education*/}
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "20px" }}
                          >
                            <label>
                              <LangData keyname="label_policy_holder_education" />
                            </label>
                            <select
                              ref={(input) =>
                                (this.policy_holder_education = input)
                              }
                              className="form-control"
                              onChange={(e) =>
                                this.setState({ education: e.target.value })
                              }
                            >
                              <option value="">Select Qualification</option>
                              <option value="S">SSC</option>
                              <option value="I">HSC</option>
                              <option value="G">GRADUATE</option>
                              <option value="P">POST GRADUATE</option>
                              <option value="O">Other</option>
                            </select>
                            {validator.policy_holder_education && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_education}
                              </span>
                            )}
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_policy_holder_place_of_birth" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Place of birth"
                              ref={(input) =>
                                (this.policy_holder_place_of_birth = input)
                              }
                              className="form-control"
                            />

                            {validator.policy_holder_place_of_birth && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_place_of_birth}
                              </span>
                            )}
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_policy_holder_nationality" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Nationality"
                              ref={(input) =>
                                (this.policy_holder_nationality = input)
                              }
                              value="Bangladeshi"
                              readOnly
                              className="form-control"
                            />

                            {validator.policy_holder_nationality && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_nationality}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "30px" }}
                          >
                            <label for="">
                              <LangData keyname="label_policy_holder_present_address" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Present Address"
                              ref={(input) =>
                                (this.policy_holder_present_address = input)
                              }
                              className="form-control"
                            />

                            {validator.policy_holder_present_address && (
                              <span className="help-block form-text text-danger">
                                {validator.policy_holder_present_address}
                              </span>
                            )}
                          </div>
                          {/* <div
                  className="col-md-6"
                  style={{ marginBottom: "30px" }}
                >
                  <label for="">
                    <LangData keyname="label_policy_holder_parmanent_address" />
                  </label>
                  <input
                    type="text"
                    placeholder="Parmanent Address"
                    ref={(input) =>
                      (this.policy_holder_parmanent_address = input)
                    }
                    className="form-control"
                  />

                </div> */}
                        </div>
                      </>
                    )}
                  </>
                )}
                {/* --------------------------------- applicants info end by nid verification--------- */}

                {/* ------------------------------------ Nominee info start -------------------------------------- */}
                {canProceedWithPolicyForm && (
                  <>
                    <div>
                      <h3
                        className="info__title"
                        style={{
                          color: "#004e8f",
                          fontSize: "22px",
                          marginTop: "25px",
                          marginBottom: "24px",
                          fontWeight: "600",
                        }}
                      >
                        <LangData keyname="label_nominee_information" />
                      </h3>
                      {/* -------------- */}
                      <div className="row mb-3">
                        <div className="col-md-4">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="hasNomineeNid"
                              checked={this.state.hasNomineeNId}
                              onChange={(e) => {
                                this.setState({
                                  hasNomineeNId: e.target.checked,
                                  /* Toggle only shows/hides the NID + Check row. The Nominee
                                     fields stay visible for manual entry; a successful Check
                                     populates them in place. */
                                  allowNomineeCustom: true,
                                  nominee_nid_value: "",
                                  currentNominee: {
                                    ...this.state.currentNominee,
                                    nominee_national_id: "",
                                  },
                                });
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="hasNomineeNid"
                            >
                              <LangData keyname="label_has_national_id" />
                            </label>
                          </div>
                        </div>
                      </div>
                      {/* -------------- */}
                      {this.state.hasNomineeNId && (
                        <div className="row">
                          <div className="col-md-4">
                            <label for="">
                              <LangData keyname="label_policy_holder_national_id" />
                              <span>*</span>
                            </label>
                            <div className="input-group mb-3">
                              <input
                                type="text"
                                placeholder="NID Number"
                                id=""
                                name="nominee_national_id"
                                value={this.state.nominee_nid_value || ""}
                                className="form-control input-control-area rounded-left"
                                style={{ borderRight: "none" }}
                                onChange={(e) => this.handleNonmineePorichoy(e)}
                                autoComplete="off"
                              />
                              <button
                                className="btn btn-primary"
                                type="button"
                                id="basic-addon2"
                                onClick={this.handleNomineeVerification}
                                disabled={
                                  !this.state.nominee_nid_value ||
                                  this.state.nominee_nid_value.length === 0 ||
                                  errors.nominee_national_id
                                }
                              >
                                <LangData keyname="label_check" />
                              </button>
                            </div>
                            {/* {errors.nominee_national_id && (
                    <div className="text-danger">
                      {errors.nominee_national_id}
                    </div>
                  )} */}
                          </div>
                        </div>
                      )}

                      {/* {!nominees?.length > 0 && allowNomineeCustom && ( */}
                      {allowNomineeCustom && (
                        <>
                          {" "}
                          {/* Nominee Information Form */}
                          <div className="row mt-3">
                            <div
                              className="col-md-3"
                              style={{ marginBottom: "35px" }}
                            >
                              <label for="">
                                <LangData keyname="label_nominee_email" />
                                {/* <span>*</span> */}
                              </label>
                              <input
                                type="email"
                                name="nominee_email"
                                value={currentNominee.nominee_email}
                                onChange={this.handleChange}
                                placeholder="Nominee Email"
                                className="form-control"
                                autoComplete="off"
                              />
                              {/* {errors.nominee_email && (
                      <div className="text-danger">
                        {errors.nominee_email}
                      </div>
                    )} */}
                            </div>

                            <div
                              className="col-md-3"
                              style={{ marginBottom: "35px" }}
                            >
                              <label for="">
                                {" "}
                                <LangData keyname="label_nominee_first_name" />
                                <span>*</span>
                              </label>
                              <input
                                type="text"
                                name="nominee_first_name"
                                value={currentNominee.nominee_first_name}
                                onChange={this.handleChange}
                                placeholder="First Name"
                                className="form-control"
                                autoComplete="off"
                              />
                              {errors.nominee_first_name && (
                                <div className="text-danger">
                                  {errors.nominee_first_name}
                                </div>
                              )}
                            </div>

                            {/* Nominee last Name */}
                            <div
                              className="col-md-3"
                              style={{ marginBottom: "35px" }}
                            >
                              <label for="">
                                {" "}
                                <LangData keyname="label_nominee_last_name" />
                                <span>*</span>
                              </label>
                              <input
                                type="text"
                                name="nominee_last_name"
                                value={currentNominee.nominee_last_name}
                                onChange={this.handleChange}
                                placeholder="Last Name"
                                className="form-control"
                                autoComplete="off"
                              />
                              {errors.nominee_first_name && (
                                <div className="text-danger">
                                  {errors.nominee_last_name}
                                </div>
                              )}
                            </div>

                            {/* Date of Birth */}
                            <div
                              className="col-md-3"
                              style={{ marginBottom: "35px" }}
                            >
                              <label for="">
                                {" "}
                                <LangData keyname="label_policy_holder_dob" />
                                <span>*</span>
                              </label>
                              {/* <input
                    type="date"
                    name="birth_date"
                    value={currentNominee.birth_date}
                    onChange={this.handleChange}
                    className="form-control"
                    max={new Date().toISOString().split("T")[0]}
                  /> */}
                              <DatePicker
                                selected={this.parseYmdToLocalDate(currentNominee.birth_date)}
                                onChange={(date) =>
                                  this.handleChange({
                                    target: {
                                      name: "birth_date",
                                      value: date
                                        ? this.formatLocalDateToYmd(date)
                                        : "",
                                    },
                                  })
                                }
                                className="form-control"
                                // dateFormat="yyyy-MM-dd"
                                dateFormat="yyyy/MM/dd"
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                autoComplete="off"
                                maxDate={new Date()}
                                // showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={100}
                                placeholderText="Select Date of Birth"
                              //  autoComplete="off"
                              />
                              {errors.birth_date && (
                                <div className="text-danger">
                                  {errors.birth_date}
                                </div>
                              )}
                            </div>

                            {/* Nominee father Name */}
                            {/* <div
                    className="col-md-3"
                    style={{ marginBottom: "35px" }}
                  >
                    <label for="">
                      {" "}
                      <LangData keyname="label_nominee_father_name" />
                    </label>
                    <input
                      type="text"
                      name="nominee_father_name"
                      value={currentNominee.nominee_father_name}
                      onChange={this.handleChange}
                      placeholder="Father Name"
                      className="form-control"
                    />
                    {errors.nominee_father_name && (
                      <div className="text-danger">
                        {errors.nominee_father_name}
                      </div>
                    )}
                  </div> */}
                            {/* Nominee mother Name */}
                            {/* <div
                    className="col-md-3"
                    style={{ marginBottom: "35px" }}
                  >
                    <label for="">
                      {" "}
                      <LangData keyname="label_nominee_mother_name" />
                    </label>
                    <input
                      type="text"
                      name="nominee_mother_name"
                      value={currentNominee.nominee_mother_name}
                      onChange={this.handleChange}
                      placeholder="Mother Name"
                      className="form-control"
                    />
                    {errors.nominee_mother_name && (
                      <div className="text-danger">
                        {errors.nominee_mother_name}
                      </div>
                    )}
                  </div> */}

                            {/* Relation */}
                            <div
                              className="col-md-3"
                              style={{ marginBottom: "35px" }}
                            >
                              <label for="">
                                {" "}
                                <LangData keyname="label_nominee_relation" />
                                <span>*</span>
                              </label>
                              <select
                                name="relation_id"
                                value={currentNominee.relation_id}
                                onChange={this.handleChange}
                                className="form-control"
                              >
                                <option value="">Select Relation</option>
                                <option value="H">Husband</option>
                                <option value="W">Wife</option>
                                <option value="F">Father</option>
                                <option value="M">Mother</option>
                                <option value="B">Brother</option>
                                {/* <option value="S">Sister</option> */}
                                {/* <option value="C">Children</option> */}
                                <option value="S">Son</option>
                                <option value="D">Daughter</option>
                                <option value="R">Relative</option>
                                <option value="O">Other</option>
                              </select>
                              {errors.relation_id && (
                                <div className="text-danger">
                                  {errors.relation_id}
                                </div>
                              )}
                            </div>
                            {/* Gender */}
                            <div
                              className="col-md-3"
                              style={{ marginBottom: "35px" }}
                            >
                              <label for="">
                                {" "}
                                <LangData keyname="label_nominee_gender" />
                                <span>*</span>
                              </label>
                              <select
                                name="nominee_gender"
                                value={currentNominee.nominee_gender}
                                onChange={this.handleChange}
                                className="form-control"
                              >
                                <option value="">Select Gender</option>
                                <option value="M">Male</option>
                                <option value="F">Female</option>
                                {/* <option value="Other">Other</option> */}
                              </select>
                              {errors.nominee_gender && (
                                <div className="text-danger">
                                  {errors.nominee_gender}
                                </div>
                              )}
                            </div>
                            {/* </div>
                <div className="row"> */}
                            {/* National ID (manual entry, available when no record was found) */}
                            <div
                              className="col-md-3"
                              style={{ marginBottom: "35px" }}
                            >
                              <label htmlFor="">
                                {" "}
                                <LangData keyname="label_policy_holder_national_id" />
                              </label>
                              <input
                                type="text"
                                name="nominee_national_id"
                                value={currentNominee.nominee_national_id || ""}
                                onChange={this.handleChange}
                                placeholder="National ID"
                                className="form-control"
                                autoComplete="off"
                              />
                              {errors.nominee_national_id && (
                                <div className="text-danger">
                                  {errors.nominee_national_id}
                                </div>
                              )}
                            </div>

                            {/* Permanent Address */}
                            {/* <div
                    className="col-md-3"
                    style={{ marginBottom: "35px" }}
                  >
                    <label for="">
                      {" "}
                      <LangData keyname="label_policy_holder_parmanent_address" />
                      <span>*</span>
                    </label>
                    <input
                      type="text"
                      name="nominee_permanent_address"
                      value={currentNominee.nominee_permanent_address}
                      onChange={this.handleChange}
                      placeholder="Permanent Address"
                      className="form-control"
                    />
                    {errors.nominee_permanent_address && (
                      <div className="text-danger">
                        {errors.nominee_permanent_address}
                      </div>
                    )}
                  </div> */}
                            {/* Present Address */}
                            <div
                              className="col-md-3"
                              style={{ marginBottom: "35px" }}
                            >
                              <label for="">
                                {" "}
                                <LangData keyname="label_policy_holder_present_address" />
                                <span>*</span>
                              </label>
                              <input
                                type="text"
                                name="nominee_present_address"
                                value={currentNominee.nominee_present_address}
                                onChange={this.handleChange}
                                placeholder="Present Address"
                                className="form-control"
                                autoComplete="off"
                              />
                              {errors.nominee_present_address && (
                                <div className="text-danger">
                                  {errors.nominee_present_address}
                                </div>
                              )}
                            </div>

                            {/* Mobile Number */}
                            <div
                              className="col-md-3"
                              style={{ marginBottom: "35px" }}
                            >
                              <label for="">
                                {" "}
                                <LangData keyname="label_nominee_mobile_number" />
                                <span>*</span>
                              </label>
                              <input
                                type="text"
                                name="nominee_mobile_no"
                                value={currentNominee.nominee_mobile_no}
                                onChange={this.handleChange}
                                placeholder="Mobile Number"
                                className="form-control"
                                autoComplete="off"
                                pattern="\d"
                              />
                              {errors.nominee_mobile_no && (
                                <div className="text-danger">
                                  {errors.nominee_mobile_no}
                                </div>
                              )}
                            </div>
                          </div>
                          {/* Buttons */}
                          {/* <button
                  type="button"
                  className="btn btn-primary mt-3"
                  onClick={this.handleNomineeSubmit}
                  disabled={nominees?.length > 0 ? true : false}
                >
                  <LangData keyname="label_nominee_information_save" />
                </button> */}
                        </>
                      )}
                    </div>

                    {/* <button >Save</button> */}
                  </>
                )}
                {/* ------------------------------------ Nominee info end  -------------------------------------- ===============================================*/}

                {/* -------------------------------- appointee information start ---------------------- */}
                {showAppointeeForm && (
                  <div>
                    <h3
                      className="info__title"
                      style={{
                        color: "#004e8f",
                        fontSize: "22px",
                        marginTop: "20px",
                        marginBottom: "24px",
                        fontWeight: "600",
                      }}
                    >
                      <LangData keyname="label_appointee_information" />
                    </h3>
                    <div className="row">
                      {/* -------------------- */}
                      {/* <div
                  className="col-md-3"
                  style={{ marginBottom: "35px" }}
                >
                  <label>
                    National ID <span>*</span>
                  </label>
                  <input
                    type="text"
                    name="appointee_national_id"
                    value={currentAppointee.appointee_national_id}
                    onChange={this.handleAppointeeChange}
                    placeholder="National ID"
                    className="form-control"
                  />
                  {errors.appointee_national_id && (
                    <div className="text-danger">
                      {errors.appointee_national_id}
                    </div>
                  )}
                </div> */}
                      {/* -------------------- */}
                      <div className="col-md-4 mb-4">
                        <label for="">
                          <LangData keyname="label_policy_holder_national_id" />
                          <span>*</span>
                        </label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            // ref={(input) => (this.policy_holder_nid = input)}
                            placeholder="NID Number"
                            id=""
                            name="appointee_national_id"
                            // value={currentAppointee.appointee_national_id}
                            value={this?.state?.appointee_nid_value || ""}
                            className="form-control input-control-area rounded-left"
                            style={{ borderRight: "none" }}
                            onChange={(e) => this.handleAppointeePorichoy(e)}
                            autoComplete="off"
                          />
                          <button
                            className="btn btn-primary"
                            type="button"
                            id="basic-addon2"
                            onClick={this.handleAppointeeVerification}
                          >
                            <LangData keyname="label_check" />
                          </button>

                          {/* {!this.state.nid_validation_err_msg && <span className="help-block form-text text-danger">The NIDD field is required.</span>} */}
                        </div>
                        {errors.appointee_national_id && (
                          <div className="text-danger">
                            {errors.appointee_national_id}
                          </div>
                        )}
                      </div>
                    </div>
                    {/* {
                allowAppointeeCustom && 
              } */}
                    {/* Appointee Information Form */}

                    {/* //  {this.state.appointees?.length > 0 && this.state.allowAppointeeCustom && ( */}
                    {this.state.allowAppointeeCustom && (
                      <>
                        {" "}
                        <div className="row">
                          {/* Appointee Email */}
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "35px" }}
                          >
                            <label for="">
                              <LangData keyname="label_appointee_email" />
                              {/* <span>*</span> */}
                            </label>
                            <input
                              type="email"
                              name="appointee_email"
                              value={currentAppointee?.appointee_email ?? ""}
                              onChange={this.handleAppointeeChange}
                              placeholder="Appointee Email"
                              className="form-control"
                              autoComplete="off"
                            />
                            {/* {errors.appointee_email && (
                        <div className="text-danger">
                          {errors.appointee_email}
                        </div>
                      )} */}
                          </div>

                          {/* Appointee First Name */}
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "35px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_nominee_first_name" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              name="appointee_first_name"
                              value={
                                currentAppointee?.appointee_first_name ?? ""
                              }
                              onChange={this.handleAppointeeChange}
                              placeholder="First Name"
                              className="form-control"
                              autoComplete="off"
                            />
                            {errors.appointee_first_name && (
                              <div className="text-danger">
                                {errors.appointee_first_name}
                              </div>
                            )}
                          </div>

                          {/* Appointee Last Name */}
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "35px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_nominee_last_name" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              name="appointee_last_name"
                              value={
                                currentAppointee?.appointee_last_name ?? ""
                              }
                              onChange={this.handleAppointeeChange}
                              placeholder="Last Name"
                              className="form-control"
                              autoComplete="off"
                            />
                            {errors.appointee_last_name && (
                              <div className="text-danger">
                                {errors.appointee_last_name}
                              </div>
                            )}
                          </div>

                          {/* Date of Birth */}
                          {/* <div
                  className="col-md-3"
                  style={{ marginBottom: "35px" }}
                >
                  <label>
                    Date of Birth <span>*</span>
                  </label>
                  <input
                    type="date"
                    name="appointee_birth_date"
                    value={currentAppointee.appointee_birth_date}
                    onChange={this.handleAppointeeChange}
                    className="form-control"
                    max={new Date().toISOString().split("T")[0]}
                  />
                  {errors.appointee_birth_date && (
                    <div className="text-danger">
                      {errors.appointee_birth_date}
                    </div>
                  )}
                </div> */}
                          {/* Date of Birth */}
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "35px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_policy_holder_dob" />
                              <span>*</span>
                            </label>
                            {/* <input
                    type="date"
                    name="birth_date"
                    value={currentNominee.birth_date}
                    onChange={this.handleChange}
                    className="form-control"
                    max={new Date().toISOString().split("T")[0]}
                  /> */}
                            <DatePicker
                              selected={this.parseYmdToLocalDate(currentAppointee?.appointee_birth_date)}
                              onChange={(date) =>
                                this.handleAppointeeChange({
                                  target: {
                                    name: "appointee_birth_date",
                                    value: date
                                      ? this.formatLocalDateToYmd(date)
                                      : "",
                                  },
                                })
                              }
                              className="form-control"
                              dateFormat="yyyy/MM/dd"
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              autoComplete="off"
                              maxDate={new Date()}
                              scrollableYearDropdown
                              yearDropdownItemNumber={100}
                              placeholderText="Select Date of Birth"
                            />
                            {errors.appointee_birth_date && (
                              <div className="text-danger">
                                {errors.appointee_birth_date}
                              </div>
                            )}
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "35px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_policy_holder_present_address" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              name="appointee_present_address"
                              value={
                                currentAppointee?.appointee_present_address ??
                                ""
                              }
                              onChange={this.handleAppointeeChange}
                              placeholder="Present Address"
                              className="form-control"
                              autoComplete="off"
                            />
                            {errors.appointee_present_address && (
                              <div className="text-danger">
                                {errors.appointee_present_address}
                              </div>
                            )}
                          </div>

                          {/* Mobile Number */}
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "35px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_nominee_mobile_number" />
                              <span>*</span>
                            </label>
                            <input
                              type="text"
                              name="appointee_mobile_no"
                              value={
                                currentAppointee?.appointee_mobile_no ?? ""
                              }
                              onChange={this.handleAppointeeChange}
                              placeholder="Mobile Number"
                              className="form-control"
                              autoComplete="off"
                            />
                            {errors.appointee_mobile_no && (
                              <div className="text-danger">
                                {errors.appointee_mobile_no}
                              </div>
                            )}
                          </div>

                          {/* Appointee Father Name */}
                          {/* <div
                  className="col-md-3"
                  style={{ marginBottom: "35px" }}
                >
                  <label>
                    Appointee Father Name <span>*</span>
                  </label>
                  <input
                    type="text"
                    name="appointee_father_name"
                    value={currentAppointee.appointee_father_name}
                    onChange={this.handleAppointeeChange}
                    placeholder="Father Name"
                    className="form-control"
                  />
                  {errors.appointee_father_name && (
                    <div className="text-danger">
                      {errors.appointee_father_name}
                    </div>
                  )}
                </div> */}

                          {/* Appointee Mother Name */}
                          {/* <div
                  className="col-md-3"
                  style={{ marginBottom: "35px" }}
                >
                  <label>
                    Appointee Mother Name <span>*</span>
                  </label>
                  <input
                    type="text"
                    name="appointee_mother_name"
                    value={currentAppointee.appointee_mother_name}
                    onChange={this.handleAppointeeChange}
                    placeholder="Mother Name"
                    className="form-control"
                  />
                  {errors.appointee_mother_name && (
                    <div className="text-danger">
                      {errors.appointee_mother_name}
                    </div>
                  )}
                </div> */}

                          {/* Relation */}
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "35px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_nominee_relation" />
                              <span>*</span>
                            </label>
                            <select
                              name="appointee_relation_id"
                              value={
                                currentAppointee?.appointee_relation_id ?? ""
                              }
                              onChange={this.handleAppointeeChange}
                              className="form-control"
                            >
                              <option value="">Select Relation</option>
                              <option value="H">Husband</option>
                              <option value="W">Wife</option>
                              <option value="F">Father</option>
                              <option value="M">Mother</option>
                              <option value="B">Brother</option>
                              <option value="S">Sister</option>
                              <option value="F">children</option>
                              <option value="O">Other</option>
                            </select>
                            {errors.appointee_relation_id && (
                              <div className="text-danger">
                                {errors.appointee_relation_id}
                              </div>
                            )}
                          </div>

                          {/* Gender */}
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "35px" }}
                          >
                            <label for="">
                              {" "}
                              <LangData keyname="label_nominee_gender" />
                              <span>*</span>
                            </label>
                            <select
                              name="appointee_gender"
                              value={currentAppointee?.appointee_gender ?? ""}
                              onChange={this.handleAppointeeChange}
                              className="form-control"
                            >
                              <option value="">Select Gender</option>
                              <option value="M">Male</option>
                              <option value="F">Female</option>
                              {/* <option value="Other">Other</option> */}
                            </select>
                            {errors.appointee_gender && (
                              <div className="text-danger">
                                {errors.appointee_gender}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row mt-3">
                          {/* National ID */}
                          {/* <div
                  className="col-md-3"
                  style={{ marginBottom: "35px" }}
                >
                  <label>
                    National ID <span>*</span>
                  </label>
                  <input
                    type="text"
                    name="appointee_national_id"
                    value={currentAppointee.appointee_national_id}
                    onChange={this.handleAppointeeChange}
                    placeholder="National ID"
                    className="form-control"
                  />
                  {errors.appointee_national_id && (
                    <div className="text-danger">
                      {errors.appointee_national_id}
                    </div>
                  )}
                </div> */}

                          {/* Permanent Address */}
                          {/* <div
                  className="col-md-3"
                  style={{ marginBottom: "35px" }}
                >
                  <label>
                    Permanent Address <span>*</span>
                  </label>
                  <input
                    type="text"
                    name="appointee_permanent_address"
                    value={currentAppointee.appointee_permanent_address}
                    onChange={this.handleAppointeeChange}
                    placeholder="Permanent Address"
                    className="form-control"
                  />
                  {errors.appointee_permanent_address && (
                    <div className="text-danger">
                      {errors.appointee_permanent_address}
                    </div>
                  )}
                </div> */}

                          {/* Present Address */}
                        </div>
                        {/* Buttons */}
                        {/* <button
                    type="button"
                    className="btn btn-primary mt-3"
                    onClick={this.handleAppointeeSubmit}
                    // disabled={appointees?.length > 0}
                  >
                    Add Appointee
                  </button> */}
                      </>
                    )}
                  </div>
                )}

                {/* -------------------------------- appointee information end ---------------------- */}
                {/* -------------------------------- agent information start ---------------------- */}
                {user?.loginuser?.role_id === 3 && (
                  <div>
                    <h3
                      className="info__title"
                      style={{
                        color: "#004e8f",
                        fontSize: "24px",
                        marginBottom: "24px",
                        fontWeight: "600",
                      }}
                    >
                      {/* Health Information:{" "} */}
                      <LangData keyname="label_bank_employee_information" />
                    </h3>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            <LangData keyname="label_transaction_id" />:
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="transaction_id"
                            value={this.state.transaction_id || ""}
                            onChange={(e) =>
                              this.setState({ transaction_id: e.target.value })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            <LangData keyname="label_collection_amount" />:
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={calCulatorData.premium_amount || ""}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* LIC employee (role 2): agent is set via "Verify your agent" at top — no Agency Code dropdown here */}
                {/* -------------------------------- agent information end ---------------------- */}

                {/* -------------------------------- health information start ---------------------- */}
                {canProceedWithPolicyForm && (
                  <>
                    <div className="mt-5"></div>
                    <h3
                      className="info__title"
                      style={{
                        color: "#004e8f",
                        fontSize: "24px",
                        marginBottom: "24px",
                        fontWeight: "600",
                      }}
                    >
                      {/* Health Information:{" "} */}
                      <LangData keyname="label_policy_holder_health_title" />
                    </h3>
                    <div className="row mt-5">
                      <div className="col-md-3" style={{ marginBottom: "30px" }}>
                        <label>
                          <LangData keyname="label_policy_holder_blood" />
                        </label>
                        {/* <span>*</span> */}
                        <input
                          type="text"
                          placeholder="Blood Information"
                          ref={(input) =>
                            (this.policy_holder_blood_information = input)
                          }
                          // value={this.state.nid_value || ""}
                          // readOnly={!!this.state.nid_value}
                          className="form-control"
                        />
                        {/* {validator.policy_holder_national_id && (
                    <span className="help-block form-text text-danger">
                      {validator.policy_holder_national_id}
                    </span>
                  )} */}
                      </div>
                      <div className="col-md-3" style={{ marginBottom: "30px" }}>
                        <label for="">
                          <LangData keyname="label_policy_holder_pulse_rate" />
                        </label>
                        {/* <span>*</span> */}
                        <input
                          type="number"
                          placeholder="Pulse Rate"
                          ref={(input) => (this.policy_holder_pulse_rate = input)}
                          className="form-control"
                        />

                        {/* {validator.policy_holder_email && (
                    <span className="help-block form-text text-danger">
                      {validator.policy_holder_email}
                    </span>
                  )} */}
                      </div>

                      <div className="col-md-3" style={{ marginBottom: "30px" }}>
                        <label for="">
                          {" "}
                          <LangData keyname="label_policy_holder_height" />
                          {/* <span>*</span> */}
                        </label>
                        <input
                          type="number"
                          placeholder="Height"
                          ref={(input) => (this.policy_holder_height = input)}
                          id=""
                          className="form-control"
                        />
                        {/* 
                  {validator.policy_holder_first_name && (
                    <span className="help-block form-text text-danger">
                      {validator.policy_holder_first_name}
                    </span>
                  )} */}
                      </div>
                      <div className="col-md-3" style={{ marginBottom: "30px" }}>
                        <label for="">
                          {" "}
                          <LangData keyname="label_policy_holder_weight" />
                          {/* <span>*</span> */}
                        </label>
                        <input
                          type="number"
                          placeholder="Weight"
                          ref={(input) => (this.policy_holder_weight = input)}
                          id=""
                          className="form-control"
                        />

                        {/* {validator.policy_holder_last_name && (
                    <span className="help-block form-text text-danger">
                      {validator.policy_holder_last_name}
                    </span>
                  )} */}
                      </div>

                      <div className="col-md-3" style={{ marginBottom: "30px" }}>
                        <label for="">
                          {" "}
                          <LangData keyname="label_policy_holder_smoker_status" />
                          {/* <span>*</span> */}
                        </label>
                        <select
                          ref={(input) =>
                            (this.policy_holder_smoker_status = input)
                          }
                          className={"form-control from-style"}
                        >
                          <option value="">Smoker Status</option>
                          <option value="Smoker">Smoker</option>
                          <option value="Non smoker">Non smoker</option>
                          {/* <option
                      value="3"
              
                    >
                      Common
                    </option> */}
                        </select>

                        {/* {validator.policy_holder_gender && (
                    <span className="help-block form-text text-danger">
                      {validator.policy_holder_gender}
                    </span>
                  )} */}
                      </div>
                    </div>
                    {/* -------------------------------- health information end ---------------------- */}
                  </>
                )}
                {/* -------------------------------- Attacht information start ---------------------- */}
                {canProceedWithPolicyForm && (
                  <>
                    <div className="mt-5"></div>
                    <h3
                      className="info__title"
                      style={{
                        color: "#004e8f",
                        fontSize: "24px",
                        marginBottom: "24px",
                        fontWeight: "600",
                      }}
                    >
                      <LangData keyname="label_policy_holder_attach_file" />
                      <span>*</span>
                    </h3>
                    <div className="mb-5">
                      {/* File Input */}
                      <input
                        type="file"
                        onChange={this.handleFileChange}
                        disabled={this?.state?.files?.length > 0 ? true : false}
                        style={{ cursor: "pointer" }}
                        accept="application/pdf"
                      />
                      <p
                        className="info__title"
                        style={{
                          fontSize: "16px",
                          marginTop: "10px",
                          // fontWeight: "600",
                        }}
                      >
                        <LangData keyname="label_file_size" />
                      </p>
                      {/* Preview Section */}
                      {this.state?.files?.length > 0 ? (
                        <div
                          style={{
                            display: "flex",
                            gap: "15px",
                            marginTop: "15px",
                          }}
                        >
                          {this.state.files.map((file) =>
                            this.renderFilePreview(file)
                          )}
                        </div>
                      ) : (
                        <div>
                          {" "}
                          {this.state?.document ? (
                            <div className="mb-4 mt-4">
                              <div
                                className="d-flex align-items-center gap-3"
                                style={{ flexDirection: "column" }}
                              >
                                {this.state?.document.match(/\.(pdf)$/i) ? (
                                  <div className="document-icon">
                                    <i
                                      className="fas fa-file-pdf"
                                      style={{ fontSize: "48px", color: "#e74c3c" }}
                                    ></i>
                                  </div>
                                ) : this.state?.document.match(
                                  /\.(jpg|jpeg|png|gif|bmp|webp)$/i
                                ) ? (
                                  <div className="document-preview">
                                    <img
                                      src={`https://licbangladesh.com/licadmin/public/${this.state?.document}`}
                                      alt="Policy Document"
                                      style={{
                                        maxWidth: "200px",
                                        maxHeight: "200px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div className="document-icon">
                                    <i
                                      className="fas fa-file-alt"
                                      style={{ fontSize: "48px", color: "#004e8f" }}
                                    ></i>
                                  </div>
                                )}
                                <div>
                                  <a
                                    href={`https://licbangladesh.com/licadmin/public/${this.state?.document}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary"
                                    download
                                  >
                                    <i className="fas fa-download me-2"></i>
                                    <LangData keyname="label_download_document" />
                                  </a>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                    </div>
                    {/* -------------------------------- Attacht information end ---------------------- */}
                  </>
                )}

                {canProceedWithPolicyForm && (
                  <>
                    <div className="mt-5"></div>

                    <div className="question-single">
                      <div className="row">
                        <div className="col-md-5">
                          <p>
                            <LangData keyname="label_policy_holder_medical_practitioner" />
                          </p>
                        </div>
                        <div className="col-md-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_medical_practitioner = input)
                              }
                              value="1"
                              checked={
                                formdata.policy_holder_medical_practitioner === 1
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_medical_practitioner",
                                  1
                                )
                              }
                            //   checked={
                            //     formdata.policy_holder_medical_practitioner === 1
                            //   }
                            />
                            <label className="form-check-label" for="inlineRadio1">
                              <LangData keyname="label_yes" />
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_medical_practitioner = input)
                              }
                              value="0"
                              checked={
                                formdata.policy_holder_medical_practitioner === 0
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_medical_practitioner",
                                  0
                                )
                              }
                            />
                            <label className="form-check-label">
                              <LangData keyname="label_no" />
                            </label>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <textarea
                            ref={(input) =>
                            (this.policy_holder_medical_practitioner_details =
                              input)
                            }
                            className="form-control"
                            readOnly={
                              formdata.policy_holder_medical_practitioner === 0
                                ? true
                                : false
                            }
                          ></textarea>

                          {validator.policy_holder_medical_practitioner_details && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_medical_practitioner_details}
                            </span>
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>

                    <div className="question-single">
                      <div className="row">
                        <div className="col-md-5">
                          <p>
                            <LangData keyname="label_policy_holder_admitted_hospital" />
                          </p>
                        </div>
                        <div className="col-md-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_admitted_hospital = input)
                              }
                              value="1"
                              checked={
                                formdata.policy_holder_admitted_hospital === 1
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_admitted_hospital",
                                  1
                                )
                              }
                            />
                            <label className="form-check-label" for="inlineRadio1">
                              <LangData keyname="label_yes" />
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_admitted_hospital = input)
                              }
                              value="0"
                              checked={
                                formdata.policy_holder_admitted_hospital === 0
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_admitted_hospital",
                                  0
                                )
                              }
                            />
                            <label className="form-check-label">
                              <LangData keyname="label_no" />
                            </label>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <textarea
                            ref={(input) =>
                              (this.policy_holder_admitted_hospital_details = input)
                            }
                            className="form-control"
                            readOnly={
                              formdata.policy_holder_admitted_hospital === 0
                                ? true
                                : false
                            }
                          ></textarea>

                          {validator.policy_holder_admitted_hospital_details && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_admitted_hospital_details}
                            </span>
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div className="question-single">
                      <div className="row">
                        <div className="col-md-5">
                          <p>
                            <LangData keyname="label_policy_holder_remained_absent" />
                          </p>
                        </div>
                        <div className="col-md-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_remained_absent = input)
                              }
                              value="1"
                              checked={
                                formdata.policy_holder_remained_absent === 1
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio("policy_holder_remained_absent", 1)
                              }
                            />
                            <label className="form-check-label" for="inlineRadio1">
                              <LangData keyname="label_yes" />
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_remained_absent = input)
                              }
                              value="0"
                              checked={
                                formdata.policy_holder_remained_absent === 0
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio("policy_holder_remained_absent", 0)
                              }
                            />
                            <label className="form-check-label">
                              <LangData keyname="label_no" />
                            </label>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <textarea
                            ref={(input) =>
                              (this.policy_holder_remained_absent_details = input)
                            }
                            className="form-control"
                            readOnly={
                              formdata.policy_holder_remained_absent === 0
                                ? true
                                : false
                            }
                          ></textarea>

                          {validator.policy_holder_remained_absent_details && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_remained_absent_details}
                            </span>
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div className="question-single">
                      <div className="row">
                        <div className="col-md-5">
                          <p>
                            <LangData keyname="label_policy_holder_suffering_ailments_pertaining" />
                          </p>
                        </div>
                        <div className="col-md-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                              (this.policy_holder_suffering_ailments_pertaining =
                                input)
                              }
                              value="1"
                              checked={
                                formdata.policy_holder_suffering_ailments_pertaining ===
                                  1
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_suffering_ailments_pertaining",
                                  1
                                )
                              }
                            />
                            <label className="form-check-label" for="inlineRadio1">
                              <LangData keyname="label_yes" />
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                              (this.policy_holder_suffering_ailments_pertaining =
                                input)
                              }
                              value="0"
                              checked={
                                formdata.policy_holder_suffering_ailments_pertaining ===
                                  0
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_suffering_ailments_pertaining",
                                  0
                                )
                              }
                            />
                            <label className="form-check-label">
                              <LangData keyname="label_no" />
                            </label>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <textarea
                            ref={(input) =>
                            (this.policy_holder_suffering_ailments_pertaining_details =
                              input)
                            }
                            className="form-control"
                            readOnly={
                              formdata.policy_holder_suffering_ailments_pertaining ===
                                0
                                ? true
                                : false
                            }
                          ></textarea>

                          {validator.policy_holder_suffering_ailments_pertaining_details && (
                            <span className="help-block form-text text-danger">
                              {
                                validator.policy_holder_suffering_ailments_pertaining_details
                              }
                            </span>
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div className="question-single">
                      <div className="row">
                        <div className="col-md-5">
                          <p>
                            <LangData keyname="label_policy_holder_suffered_diabetes_others" />
                          </p>
                        </div>
                        <div className="col-md-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                              (this.policy_holder_suffered_diabetes_others =
                                input)
                              }
                              value="1"
                              checked={
                                formdata.policy_holder_suffered_diabetes_others ===
                                  1
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_suffered_diabetes_others",
                                  1
                                )
                              }
                            />
                            <label className="form-check-label" for="inlineRadio1">
                              <LangData keyname="label_yes" />
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                              (this.policy_holder_suffered_diabetes_others =
                                input)
                              }
                              value="0"
                              checked={
                                formdata.policy_holder_suffered_diabetes_others ===
                                  0
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_suffered_diabetes_others",
                                  0
                                )
                              }
                            />
                            <label className="form-check-label">
                              <LangData keyname="label_no" />
                            </label>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <textarea
                            ref={(input) =>
                            (this.policy_holder_suffered_diabetes_others_details =
                              input)
                            }
                            className="form-control"
                            readOnly={
                              formdata.policy_holder_suffered_diabetes_others === 0
                                ? true
                                : false
                            }
                          ></textarea>

                          {validator.policy_holder_suffered_diabetes_others_details && (
                            <span className="help-block form-text text-danger">
                              {
                                validator.policy_holder_suffered_diabetes_others_details
                              }
                            </span>
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div className="question-single">
                      <div className="row">
                        <div className="col-md-5">
                          <p>
                            <LangData keyname="label_policy_holder_bodily_defect_deformity" />
                          </p>
                        </div>
                        <div className="col-md-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_bodily_defect_deformity = input)
                              }
                              value="1"
                              checked={
                                formdata.policy_holder_bodily_defect_deformity === 1
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_bodily_defect_deformity",
                                  1
                                )
                              }
                            />
                            <label className="form-check-label" for="inlineRadio1">
                              <LangData keyname="label_yes" />
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_bodily_defect_deformity = input)
                              }
                              value="0"
                              checked={
                                formdata.policy_holder_bodily_defect_deformity === 0
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_bodily_defect_deformity",
                                  0
                                )
                              }
                            />
                            <label className="form-check-label">
                              <LangData keyname="label_no" />
                            </label>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <textarea
                            ref={(input) =>
                            (this.policy_holder_bodily_defect_deformity_details =
                              input)
                            }
                            className="form-control"
                            readOnly={
                              formdata.policy_holder_bodily_defect_deformity === 0
                                ? true
                                : false
                            }
                          ></textarea>

                          {validator.policy_holder_bodily_defect_deformity_details && (
                            <span className="help-block form-text text-danger">
                              {
                                validator.policy_holder_bodily_defect_deformity_details
                              }
                            </span>
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div className="question-single">
                      <div className="row">
                        <div className="col-md-5">
                          <p>
                            <LangData keyname="label_policy_holder_accident_injury" />
                          </p>
                        </div>
                        <div className="col-md-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_accident_injury = input)
                              }
                              value="1"
                              checked={
                                formdata.policy_holder_accident_injury === 1
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio("policy_holder_accident_injury", 1)
                              }
                            />
                            <label className="form-check-label" for="inlineRadio1">
                              <LangData keyname="label_yes" />
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_accident_injury = input)
                              }
                              value="0"
                              checked={
                                formdata.policy_holder_accident_injury === 0
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio("policy_holder_accident_injury", 0)
                              }
                            />

                            <label className="form-check-label">
                              <LangData keyname="label_no" />
                            </label>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <textarea
                            ref={(input) =>
                              (this.policy_holder_accident_injury_details = input)
                            }
                            className="form-control"
                            readOnly={
                              formdata.policy_holder_accident_injury === 0
                                ? true
                                : false
                            }
                          ></textarea>

                          {validator.policy_holder_accident_injury_details && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_accident_injury_details}
                            </span>
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div className="question-single">
                      <div className="row">
                        <div className="col-md-5">
                          <p>
                            <LangData keyname="label_policy_holder_used_alcoholic_others" />
                            <br></br>
                            <LangData keyname="label_policy_holder_used_alcoholic_others_option" />
                          </p>
                        </div>
                        <div className="col-md-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_used_alcoholic_others = input)
                              }
                              value="1"
                              checked={
                                formdata.policy_holder_used_alcoholic_others === 1
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_used_alcoholic_others",
                                  1
                                )
                              }
                            />
                            <label className="form-check-label" for="inlineRadio1">
                              <LangData keyname="label_yes" />
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_used_alcoholic_others = input)
                              }
                              value="0"
                              checked={
                                formdata.policy_holder_used_alcoholic_others === 0
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio(
                                  "policy_holder_used_alcoholic_others",
                                  0
                                )
                              }
                            />
                            <label className="form-check-label">
                              <LangData keyname="label_no" />
                            </label>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <textarea
                            ref={(input) =>
                            (this.policy_holder_used_alcoholic_others_details =
                              input)
                            }
                            className="form-control"
                            readOnly={
                              formdata.policy_holder_used_alcoholic_others === 0
                                ? true
                                : false
                            }
                          ></textarea>

                          {validator.policy_holder_used_alcoholic_others_details && (
                            <span className="help-block form-text text-danger">
                              {
                                validator.policy_holder_used_alcoholic_others_details
                              }
                            </span>
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>

                    <div className="question-single">
                      <div className="row">
                        <div className="col-md-5">
                          <p>
                            <LangData keyname="label_policy_holder_good_health" />
                          </p>
                        </div>
                        <div className="col-md-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_good_health = input)
                              }
                              value="1"
                              checked={
                                formdata.policy_holder_good_health === 1
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio("policy_holder_good_health", 1)
                              }
                            />
                            <label className="form-check-label" for="inlineRadio1">
                              <LangData keyname="label_yes" />
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_good_health = input)
                              }
                              value="0"
                              checked={
                                formdata.policy_holder_good_health === 0
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio("policy_holder_good_health", 0)
                              }
                            />
                            <label className="form-check-label">
                              <LangData keyname="label_no" />
                            </label>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <textarea
                            ref={(input) =>
                              (this.policy_holder_good_health_details = input)
                            }
                            className="form-control"
                            readOnly={
                              formdata.policy_holder_good_health === 0
                                ? true
                                : false
                            }
                          ></textarea>

                          {validator.policy_holder_good_health_details && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_good_health_details}
                            </span>
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>

                    <div className="question-single mb-5">
                      <div className="row">
                        <div className="col-md-5">
                          <p>
                            <LangData keyname="label_policy_holder_aids_hepatitis" />
                          </p>
                        </div>
                        <div className="col-md-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_aids_hepatitis = input)
                              }
                              value="1"
                              checked={
                                formdata.policy_holder_aids_hepatitis === 1
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio("policy_holder_aids_hepatitis", 1)
                              }
                            />
                            <label className="form-check-label" for="inlineRadio1">
                              <LangData keyname="label_yes" />
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              ref={(input) =>
                                (this.policy_holder_aids_hepatitis = input)
                              }
                              value="0"
                              checked={
                                formdata.policy_holder_aids_hepatitis === 0
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                this.handleRadio("policy_holder_aids_hepatitis", 0)
                              }
                            />
                            <label className="form-check-label">
                              <LangData keyname="label_no" />
                            </label>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <textarea
                            ref={(input) =>
                              (this.policy_holder_aids_hepatitis_details = input)
                            }
                            className="form-control"
                            readOnly={
                              formdata.policy_holder_aids_hepatitis === 0
                                ? true
                                : false
                            }
                          ></textarea>

                          {validator.policy_holder_aids_hepatitis_details && (
                            <span className="help-block form-text text-danger">
                              {validator.policy_holder_aids_hepatitis_details}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {isEditing ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-success mb-5"
                      onClick={() => this.handleSubmit(true, true)}
                    >
                      <LangData keyname="label_update" />
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger mb-5 ml-2"
                      onClick={this.handleCancel}
                    >
                      <LangData keyname="label_cancel" />
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary mb-5 ml-2"
                      onClick={() => this.handleSubmit(false, false)}
                      disabled={user?.loginguser?.id === 1}
                    >
                      <LangData keyname="label_save_confirm" />
                    </button>
                  </div>
                ) : (
                  showPolicySubmitActions && (
                    <div>
                      <button
                        type="button"
                        className="btn btn-primary mb-5"
                        onClick={() => this.handleSubmit(true, true)}
                        disabled={user?.loginguser?.id === 1}
                      >
                        <LangData keyname="label_save_draft" />
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary mb-5 ml-2"
                        onClick={() => this.handleSubmit(false, false)}
                        disabled={user?.loginguser?.id === 1}
                      >
                        <LangData keyname="label_save_confirm" />
                      </button>
                    </div>
                  )
                )}
              </div>
            </Tab>
            <Tab></Tab>
          </Tabs>
        </form>
        {this.state.showCalculatorModal && (
          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.65)",
              zIndex: 1050,
              overflowY: "auto",
            }}
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-xl modal-dialog-centered"
              role="document"
              style={{ maxWidth: "1150px", margin: "30px auto" }}
            >
              <div
                className="modal-content"
                style={{
                  borderRadius: "10px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
                  border: "none",
                }}
              >
                <div
                  className="modal-header"
                  style={{
                    backgroundColor: "#004e8f",
                    color: "#fff",
                    borderTopLeftRadius: "9px",
                    borderTopRightRadius: "9px",
                    padding: "16px 24px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h5
                    className="modal-title m-0"
                    style={{ color: "#fff", fontWeight: 600 }}
                  >
                    <i className="fa fa-calculator mr-2"></i>
                    {lang === "bn"
                      ? "প্রিমিয়াম ক্যালকুলেটর ও প্ল্যান নির্বাচন"
                      : "Premium Calculator & Plan Selection"}
                  </h5>
                  <button
                    type="button"
                    className="close text-white"
                    style={{
                      fontSize: "1.5rem",
                      opacity: 0.9,
                      textShadow: "none",
                      outline: "none",
                    }}
                    onClick={() =>
                      this.setState({ showCalculatorModal: false })
                    }
                  >
                    &times;
                  </button>
                </div>
                <div
                  className="modal-body p-4"
                  style={{ backgroundColor: "#fbfcfd" }}
                >
                  <PremiumcalCulatorform
                    isModal={true}
                    initialValues={{
                      dob:
                        this.state.customer?.date_of_birth ||
                        calCulatorData?.dateOf_birth ||
                        calCulatorData?.date_of_birth,
                      doc:
                        calCulatorData?.date_of_commencement ||
                        calCulatorData?.payload?.doc ||
                        new Date(),
                      gender:
                        this.state.customer?.gender === "Male" ||
                        this.state.customer?.gender === "M"
                          ? "M"
                          : this.state.customer?.gender === "Female" ||
                            this.state.customer?.gender === "F"
                            ? "F"
                            : calCulatorData?.payload?.gender || "M",
                    }}
                    onApply={this.handleCalculatorApply}
                    onClose={() =>
                      this.setState({ showCalculatorModal: false })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {/* {isModalOpen && (
    <DraftTable
      isOpen={isModalOpen}
      onRequestClose={this.closeModal}
      onEdit={this.handleEdit}
    />
  )} */}
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  returnCalculator: state.returnCalculator,
  user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
  setPath: (requestData) => {
    dispatch(setPath(requestData));
  },
  setLayout: (requestData) => {
    dispatch(setLayout(requestData));
  },
  setPathLayout: (requestData) => {
    dispatch(setPathLayout(requestData));
  },
  sendContactus: (requestData) => {
    dispatch(sendContactus(requestData));
  },
  getPoliciesBasedOnAge: (requestData) =>
    dispatch(getPoliciesBasedOnAge(requestData)),
  getTermsBasedOnPolicy: (requestData) =>
    dispatch(getTermsBasedOnPolicy(requestData)),
  getSumAssuredValidation: (requestData) =>
    dispatch(getSumAssuredValidation(requestData)),
  getCalculations: (requestData) => dispatch(getCalculations(requestData)),
  setReturnalCalculatorData: (requestData) =>
    dispatch(setReturnalCalculatorData(requestData)),
  customerPoricyNid: (requestData) => dispatch(customerPoricyNid(requestData)),
  policyAdd: (requestData) => dispatch(policyAdd(requestData)),
  policyNomineeAdd: (requestData) => dispatch(policyNomineeAdd(requestData)),
});

// Wrap the class component to use hooks
const PolicyformWithRouter = (props) => {
  const location = useLocation();
  return <Policyform {...props} location={location} />;
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PolicyformWithRouter)
);
